!(function (t) {
  function e(e) {
    for (var r, a, o = e[0], l = e[1], u = e[2], h = 0, d = []; h < o.length; h++)
      (a = o[h]), Object.prototype.hasOwnProperty.call(n, a) && n[a] && d.push(n[a][0]), (n[a] = 0);
    for (r in l) Object.prototype.hasOwnProperty.call(l, r) && (t[r] = l[r]);
    for (c && c(e); d.length;) d.shift()();
    return s.push.apply(s, u || []), i();
  }
  function i() {
    for (var t, e = 0; e < s.length; e++) {
      for (var i = s[e], r = !0, o = 1; o < i.length; o++) {
        var l = i[o];
        0 !== n[l] && (r = !1);
      }
      r && (s.splice(e--, 1), (t = a((a.s = i[0]))));
    }
    return t;
  }
  var r = {},
    n = { 9: 0 },
    s = [];
  function a(e) {
    if (r[e]) return r[e].exports;
    var i = (r[e] = { i: e, l: !1, exports: {} });
    return t[e].call(i.exports, i, i.exports, a), (i.l = !0), i.exports;
  }
  (a.m = t),
    (a.c = r),
    (a.d = function (t, e, i) {
      a.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
    }),
    (a.r = function (t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (a.t = function (t, e) {
      if ((1 & e && (t = a(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (
        (a.r(i),
          Object.defineProperty(i, 'default', { enumerable: !0, value: t }),
          2 & e && 'string' != typeof t)
      )
        for (var r in t)
          a.d(
            i,
            r,
            function (e) {
              return t[e];
            }.bind(null, r)
          );
      return i;
    }),
    (a.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
            return t.default;
          }
          : function () {
            return t;
          };
      return a.d(e, 'a', e), e;
    }),
    (a.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (a.p = '');
  var o = (window.shopifySlateJsonp = window.shopifySlateJsonp || []),
    l = o.push.bind(o);
  (o.push = e), (o = o.slice());
  for (var u = 0; u < o.length; u++) e(o[u]);
  var c = l;
  s.push([219, 0, 1]), i();
})({
  16: function (t, e) {
    var i;
    i = (function () {
      return this;
    })();
    try {
      i = i || new Function('return this')();
    } catch (t) {
      'object' == typeof window && (i = window);
    }
    t.exports = i;
  },
  2: function (t, e, i) {
    'use strict';
    function r(t, e, i, r, n, s, a, o) {
      var l,
        u = 'function' == typeof t ? t.options : t;
      if (
        (e && ((u.render = e), (u.staticRenderFns = i), (u._compiled = !0)),
          r && (u.functional = !0),
          s && (u._scopeId = 'data-v-' + s),
          a
            ? ((l = function (t) {
              (t =
                t ||
                (this.$vnode && this.$vnode.ssrContext) ||
                (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext)) ||
                'undefined' == typeof __VUE_SSR_CONTEXT__ ||
                (t = __VUE_SSR_CONTEXT__),
                n && n.call(this, t),
                t && t._registeredComponents && t._registeredComponents.add(a);
            }),
              (u._ssrRegister = l))
            : n &&
            (l = o
              ? function () {
                n.call(this, this.$root.$options.shadowRoot);
              }
              : n),
          l)
      )
        if (u.functional) {
          u._injectStyles = l;
          var c = u.render;
          u.render = function (t, e) {
            return l.call(e), c(t, e);
          };
        } else {
          var h = u.beforeCreate;
          u.beforeCreate = h ? [].concat(h, l) : [l];
        }
      return { exports: t, options: u };
    }
    i.d(e, 'a', function () {
      return r;
    });
  },
  219: function (t, e, i) {
    'use strict';
    i.r(e);
    var r = i(9),
      n = (i(91), i(70), i(15)),
      s = i.n(n),
      a = i(2),
      o = Object(a.a)(
        { name: 'featured-collections-header', props: ['data'] },
        function () {
          var t = this.$createElement,
            e = this._self._c || t;
          return e('div', { staticClass: 'featured-collections-header' }, [
            e('h2', { staticClass: 'featured-collections-header__title' }, [
              this._v('\n    ' + this._s(this.data.title) + '\n  '),
            ]),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports,
      l = i(25),
      u = i.n(l),
      c = i(14),
      h = i(0),
      d = {
        name: 'featured-collections-slider',
        props: ['data'],
        data: () => ({ isCarousel: !1, carousel: '', width: '', height: '' }),
        methods: {
          constructCarousel() {
            this.isCarousel ||
              ((this.isCarousel = !0),
                (this.width = ''),
                (this.height = ''),
                this.$refs.slider &&
                (this.carousel = new u.a(this.$refs.slider, {
                  speed: 500,
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                  navigation: { nextEl: this.$refs.next, prevEl: this.$refs.prev },
                  breakpoints: { 1024: { spaceBetween: 0 } },
                })));
          },
          handleResizeEvent() {
            window.matchMedia('(min-width: '.concat(c.a.large, ')')).matches
              ? this.destroyCarousel()
              : this.constructCarousel();
          },
          setEventListeners() {
            Object(h.h)(
              'resize',
              Object(h.a)(() => this.handleResizeEvent(), 250)
            );
          },
          destroyCarousel() {
            this.isCarousel && this.carousel && (this.carousel.destroy(), (this.isCarousel = !1));
          },
        },
        mounted() {
          this.setEventListeners(), this.handleResizeEvent();
        },
      },
      f = Object(a.a)(
        d,
        function () {
          var t = this,
            e = t.$createElement,
            i = t._self._c || e;
          return i('div', { ref: 'container', staticClass: 'featured-collections-slider' }, [
            i(
              'div',
              {
                ref: 'slider',
                staticClass: 'swiper-container featured-collections-slider__slider',
              },
              [
                i(
                  'div',
                  { staticClass: 'swiper-wrapper' },
                  t._l(t.data.slides, function (e, r) {
                    return i(
                      'div',
                      { key: r, staticClass: 'swiper-slide featured-collections-slider__slide' },
                      [
                        i(
                          'a',
                          {
                            staticClass: 'featured-collections-slider__card',
                            attrs: { href: e.linkUrl },
                          },
                          [
                            i('div', { staticClass: 'ratio-box ratio-box--3-4' }, [
                              i('div', { staticClass: 'ratio-box__content' }, [
                                i(
                                  'div',
                                  { staticClass: 'featured-collections-slider__image-wrapper' },
                                  [
                                    i('img', {
                                      staticClass: 'featured-collections-slider__image lazyload',
                                      attrs: {
                                        'data-src': e.image.highResUrl,
                                        alt: e.image.alt,
                                        width: e.image.width,
                                        height: e.image.height,
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            t._v(' '),
                            i('div', { staticClass: 'featured-collections-slider__footer' }, [
                              i(
                                'div',
                                { staticClass: 'featured-collections-slider__footer-wrapper' },
                                [
                                  i('span', { staticClass: 'h6' }, [t._v(t._s(e.title))]),
                                  t._v(' '),
                                  i(
                                    'div',
                                    { staticClass: 'featured-collections-slider__footer-button' },
                                    [
                                      i('span', { staticClass: 'button-text' }, [
                                        t._v(t._s(e.linkLabel)),
                                      ]),
                                      t._v(' '),
                                      i(
                                        'svg',
                                        {
                                          staticClass: 'icon icon__arrow icon__arrow--right',
                                          attrs: {
                                            viewBox: '0 0 24 24',
                                            xmlns: 'http://www.w3.org/2000/svg',
                                          },
                                        },
                                        [
                                          i('path', {
                                            attrs: {
                                              fill: '#22262E',
                                              d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z',
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    );
                  }),
                  0
                ),
                t._v(' '),
                t.data.showSliderNav
                  ? i('div', { staticClass: 'featured-collections-slider__nav' }, [
                    i(
                      'button',
                      { ref: 'prev', staticClass: 'featured-collections-slider__nav-item' },
                      [
                        i(
                          'svg',
                          {
                            staticClass: 'icon icon__chevron icon__chevron--left',
                            attrs: {
                              xmlns: 'http://www.w3.org/2000/svg',
                              fill: 'none',
                              viewBox: '0 0 16 28',
                            },
                          },
                          [
                            i('defs'),
                            t._v(' '),
                            i('path', {
                              attrs: {
                                fill: '#22262E',
                                'fill-rule': 'evenodd',
                                d: 'M3.414 14L15.707 1.707 14.293.293.586 14l13.707 13.707 1.414-1.414L3.414 14z',
                                'clip-rule': 'evenodd',
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    t._v(' '),
                    i(
                      'button',
                      { ref: 'next', staticClass: 'featured-collections-slider__nav-item' },
                      [
                        i(
                          'svg',
                          {
                            staticClass: 'icon icon__chevron icon__chevron--right',
                            attrs: {
                              xmlns: 'http://www.w3.org/2000/svg',
                              fill: 'none',
                              viewBox: '0 0 16 28',
                            },
                          },
                          [
                            i('defs'),
                            t._v(' '),
                            i('path', {
                              attrs: {
                                fill: '#22262E',
                                'fill-rule': 'evenodd',
                                d: 'M12.586 14L.293 26.293l1.414 1.414L15.414 14 1.707.293.293 1.707 12.586 14z',
                                'clip-rule': 'evenodd',
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ])
                  : t._e(),
              ]
            ),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports;
    Object(r.b)('featured-collections', {
      cacheSelectors() {
        const t = '[data-section-id="'.concat(this.id, '"]'),
          e = ''.concat(t, ' ').concat('[js-featured-collections="container"]'),
          i = ''.concat(t, ' ').concat('[js-featured-collections="data"]');
        this.cache = { section: t, container: e, data: i };
      },
      setData() {
        (this.dataEl = document.querySelector(this.cache.data)),
          (this.data = Object.freeze(JSON.parse(this.dataEl.innerHTML)));
      },
      init() {
        new s.a({
          el: this.cache.container,
          data: { sectionData: this.data, currentSlide: 0 },
          components: { FeaturedCollectionsHeader: o, FeaturedCollectionsSlider: f },
          methods: {
            updateCurrentSlide(t) {
              this.currentSlide = t;
            },
            setPaddingBottom() {
              this.sectionData.showSliderNav && this.$refs.container.classList.add('is-navigation');
            },
          },
          mounted() {
            this.setPaddingBottom();
          },
        });
      },
      onLoad() {
        this.cacheSelectors(), this.setData(), this.init();
      },
    });
    var p = {
      props: ['data'],
      data: () => ({ isCarousel: !1, carousel: '' }),
      mounted() {
        this.setEventListeners(), this.handleResizeEvent();
      },
      methods: {
        constructCarousel() {
          this.isCarousel ||
            ((this.isCarousel = !0),
              this.$refs.slider &&
              (this.carousel = new u.a(this.$refs.slider, {
                loop: !0,
                speed: 500,
                slidesPerView: 1,
                pagination: {
                  el: this.$refs.pagination,
                  clickable: !0,
                  renderBullet: (t, e) => "<button class='".concat(e, "'></button>"),
                },
                breakpoints: {
                  576: { watchSlidesVisibility: !0, slidesPerView: 2, slidesPerGroup: 2 },
                  768: { slidesPerView: 1, slidesPerGroup: 1 },
                },
              })));
        },
        handleResizeEvent() {
          window.matchMedia('(min-width: '.concat(c.a.large, ')')).matches
            ? this.destroyCarousel()
            : this.constructCarousel();
        },
        setEventListeners() {
          Object(h.h)(
            'resize',
            Object(h.a)(() => this.handleResizeEvent(), 250)
          );
        },
        destroyCarousel() {
          this.isCarousel && this.carousel && (this.carousel.destroy(), (this.isCarousel = !1));
        },
      },
    },
      _ = Object(a.a)(
        p,
        function () {
          var t = this,
            e = t.$createElement,
            i = t._self._c || e;
          return i('div', { ref: 'container', staticClass: 'press-features-slider' }, [
            i(
              'div',
              { ref: 'slider', staticClass: 'swiper-container press-features-slider__slider' },
              [
                i(
                  'div',
                  { staticClass: 'swiper-wrapper' },
                  t._l(t.data.slides, function (e, r) {
                    return i(
                      'div',
                      { key: r, staticClass: 'swiper-slide press-features-slider__slide' },
                      [
                        i('div', { staticClass: 'press-features-slider__wrapper' }, [
                          i('div', { staticClass: 'press-features-slider__card' }, [
                            i('div', { staticClass: 'press-features-slider__logo' }, [
                              i('img', {
                                staticClass: 'press-features-slider__image lazyload blur-up',
                                attrs: { alt: e.image.alt, 'data-src': e.image.url },
                              }),
                            ]),
                            t._v(' '),
                            i('div', {
                              staticClass: 'press-features-slider__quote',
                              domProps: { innerHTML: t._s(e.quote) },
                            }),
                          ]),
                        ]),
                      ]
                    );
                  }),
                  0
                ),
                t._v(' '),
                i('div', { ref: 'pagination' }),
              ]
            ),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports;
    Object(r.b)('press-features', {
      cacheSelectors() {
        const t = '[data-section-id="'.concat(this.id, '"]'),
          e = ''.concat(t, ' ').concat('[js-press-features="container"]'),
          i = ''.concat(t, ' ').concat('[js-press-features="data"]');
        this.cache = { section: t, container: e, data: i };
      },
      setData() {
        (this.dataEl = document.querySelector(this.cache.data)),
          (this.data = Object.freeze(JSON.parse(this.dataEl.innerHTML)));
      },
      init() {
        new s.a({
          el: this.cache.container,
          components: { PressFeaturesSlider: _ },
          data: { sectionData: this.data },
        });
      },
      onLoad() {
        this.cacheSelectors(), this.setData(), this.init();
      },
    });
    var m = {
      name: 'shop-by-room-text-block',
      props: ['data', 'current-slide'],
      methods: {
        setCurrentSlide(t) {
          this.$emit('update-current-slide', t);
        },
      },
    },
      g = Object(a.a)(
        m,
        function () {
          var t = this,
            e = t.$createElement,
            i = t._self._c || e;
          return i('div', { staticClass: 'shop-by-room-text-block' }, [
            i('div', { staticClass: 'shop-by-room-text-block__bg' }, [
              i('div', { staticClass: 'shop-by-room-text-block__header' }, [
                i('h2', { staticClass: 'shop-by-room-text-block__title' }, [
                  t._v('\n        ' + t._s(t.data.heading) + '\n      '),
                ]),
                t._v(' '),
                i('div', {
                  staticClass: 'shop-by-room-text-block__body',
                  domProps: { innerHTML: t._s(t.data.body) },
                }),
              ]),
              t._v(' '),
              i(
                'div',
                { staticClass: 'shop-by-room-text-block__nav' },
                t._l(t.data.slides, function (e, r) {
                  return i(
                    'a',
                    {
                      key: r,
                      staticClass: 'shop-by-room-text-block__button',
                      class: { 'is-active': t.currentSlide === r },
                      attrs: { href: e.linkUrl },
                      on: {
                        mouseover: function (e) {
                          return t.setCurrentSlide(r);
                        },
                        focus: function (e) {
                          return t.setCurrentSlide(r);
                        },
                      },
                    },
                    [
                      i('span', { staticClass: 'h4' }, [t._v(t._s(e.title))]),
                      t._v(' '),
                      i(
                        'svg',
                        {
                          staticClass: 'icon shop-by-room-slider__icon-arrow',
                          attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 33 17' },
                        },
                        [
                          i('defs'),
                          t._v(' '),
                          i('path', {
                            attrs: {
                              fill: '#F2F2F2',
                              'fill-rule': 'evenodd',
                              d: 'M29.69 7.75l-6.22-6.22L24.53.47l8.03 8.03-8.03 8.03-1.06-1.06 6.22-6.22H0v-1.5h29.69z',
                              'clip-rule': 'evenodd',
                            },
                          }),
                        ]
                      ),
                    ]
                  );
                }),
                0
              ),
            ]),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports,
      v = {
        props: ['data', 'current-slide'],
        data: () => ({ isCarousel: !1, carousel: '' }),
        mounted() {
          this.setEventListeners(), this.handleResizeEvent();
        },
        methods: {
          constructCarousel() {
            this.isCarousel ||
              ((this.isCarousel = !0),
                this.$refs.slider &&
                (this.carousel = new u.a(this.$refs.slider, {
                  speed: 500,
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                  breakpoints: { 1024: { spaceBetween: 0 } },
                })));
          },
          handleFocusEvent(t) {
            this.$emit('update-current-slide', t);
          },
          changeSlide(t) {
            this.carousel.slideTo(t);
          },
          handleResizeEvent() {
            window.matchMedia('(min-width: '.concat(c.a.large, ')')).matches
              ? this.destroyCarousel()
              : this.constructCarousel();
          },
          setEventListeners() {
            Object(h.h)(
              'resize',
              Object(h.a)(() => this.handleResizeEvent(), 250)
            );
          },
          destroyCarousel() {
            this.isCarousel && this.carousel && (this.carousel.destroy(), (this.isCarousel = !1));
          },
        },
      },
      y = Object(a.a)(
        v,
        function () {
          var t = this,
            e = t.$createElement,
            i = t._self._c || e;
          return i('div', { ref: 'container', staticClass: 'shop-by-room-slider' }, [
            i(
              'div',
              { ref: 'slider', staticClass: 'swiper-container shop-by-room-slider__slider' },
              [
                i(
                  'div',
                  { staticClass: 'swiper-wrapper' },
                  t._l(t.data.slides, function (e, r) {
                    return i(
                      'div',
                      {
                        key: r,
                        staticClass: 'swiper-slide shop-by-room-slider__slide',
                        class: { 'is-active': t.currentSlide === r },
                      },
                      [
                        i(
                          'a',
                          {
                            staticClass: 'shop-by-room-slider__link',
                            attrs: { href: e.linkUrl, 'aria-label': 'shop-by-room-slider ' + r },
                            on: {
                              focus: function (e) {
                                return t.handleFocusEvent(r);
                              },
                            },
                          },
                          [
                            i('div', { staticClass: 'shop-by-room-slider__card' }, [
                              i('img', {
                                staticClass: 'shop-by-room-slider__image lazyload',
                                attrs: { 'data-src': e.image.highResUrl, alt: e.image.alt },
                              }),
                              t._v(' '),
                              i('div', { staticClass: 'shop-by-room-slider__card-footer' }, [
                                i('h3', { staticClass: 'h4 shop-by-room-slider__title' }, [
                                  t._v('\n                ' + t._s(e.title) + '\n              '),
                                ]),
                                t._v(' '),
                                i(
                                  'svg',
                                  {
                                    staticClass: 'icon shop-by-room-slider__icon-arrow',
                                    attrs: {
                                      xmlns: 'http://www.w3.org/2000/svg',
                                      viewBox: '0 0 33 17',
                                    },
                                  },
                                  [
                                    i('defs'),
                                    t._v(' '),
                                    i('path', {
                                      attrs: {
                                        fill: '#22262E',
                                        'fill-rule': 'evenodd',
                                        d: 'M29.69 7.75l-6.22-6.22L24.53.47l8.03 8.03-8.03 8.03-1.06-1.06 6.22-6.22H0v-1.5h29.69z',
                                        'clip-rule': 'evenodd',
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    );
                  }),
                  0
                ),
              ]
            ),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports;
    Object(r.b)('shop-by-room', {
      cacheSelectors() {
        const t = '[data-section-id="'.concat(this.id, '"]'),
          e = ''.concat(t, ' ').concat('[js-shop-by-room="container"]'),
          i = ''.concat(t, ' ').concat('[js-shop-by-room="data"]');
        this.cache = { section: t, container: e, data: i };
      },
      setData() {
        (this.dataEl = document.querySelector(this.cache.data)),
          (this.data = Object.freeze(JSON.parse(this.dataEl.innerHTML)));
      },
      init() {
        new s.a({
          el: this.cache.container,
          data: { sectionData: this.data, currentSlide: 0 },
          components: { ShopByRoomTextBlock: g, ShopByRoomSlider: y },
          methods: {
            updateCurrentSlide(t) {
              this.currentSlide = t;
            },
          },
        });
      },
      onLoad() {
        this.cacheSelectors(), this.setData(), this.init();
      },
    }),
      document.addEventListener('DOMContentLoaded', () => {
        Object(r.a)('*');
      });
  },
  29: function (t, e, i) {
    (function (t, e) {
      !(function (t, i) {
        'use strict';
        if (!t.setImmediate) {
          var r,
            n = 1,
            s = {},
            a = !1,
            o = t.document,
            l = Object.getPrototypeOf && Object.getPrototypeOf(t);
          (l = l && l.setTimeout ? l : t),
            '[object process]' === {}.toString.call(t.process)
              ? (r = function (t) {
                e.nextTick(function () {
                  c(t);
                });
              })
              : (function () {
                if (t.postMessage && !t.importScripts) {
                  var e = !0,
                    i = t.onmessage;
                  return (
                    (t.onmessage = function () {
                      e = !1;
                    }),
                    t.postMessage('', '*'),
                    (t.onmessage = i),
                    e
                  );
                }
              })()
                ? (function () {
                  var e = 'setImmediate$' + Math.random() + '$',
                    i = function (i) {
                      i.source === t &&
                        'string' == typeof i.data &&
                        0 === i.data.indexOf(e) &&
                        c(+i.data.slice(e.length));
                    };
                  t.addEventListener
                    ? t.addEventListener('message', i, !1)
                    : t.attachEvent('onmessage', i),
                    (r = function (i) {
                      t.postMessage(e + i, '*');
                    });
                })()
                : t.MessageChannel
                  ? (function () {
                    var t = new MessageChannel();
                    (t.port1.onmessage = function (t) {
                      c(t.data);
                    }),
                      (r = function (e) {
                        t.port2.postMessage(e);
                      });
                  })()
                  : o && 'onreadystatechange' in o.createElement('script')
                    ? (function () {
                      var t = o.documentElement;
                      r = function (e) {
                        var i = o.createElement('script');
                        (i.onreadystatechange = function () {
                          c(e), (i.onreadystatechange = null), t.removeChild(i), (i = null);
                        }),
                          t.appendChild(i);
                      };
                    })()
                    : (r = function (t) {
                      setTimeout(c, 0, t);
                    }),
            (l.setImmediate = function (t) {
              'function' != typeof t && (t = new Function('' + t));
              for (var e = new Array(arguments.length - 1), i = 0; i < e.length; i++)
                e[i] = arguments[i + 1];
              var a = { callback: t, args: e };
              return (s[n] = a), r(n), n++;
            }),
            (l.clearImmediate = u);
        }
        function u(t) {
          delete s[t];
        }
        function c(t) {
          if (a) setTimeout(c, 0, t);
          else {
            var e = s[t];
            if (e) {
              a = !0;
              try {
                !(function (t) {
                  var e = t.callback,
                    i = t.args;
                  switch (i.length) {
                    case 0:
                      e();
                      break;
                    case 1:
                      e(i[0]);
                      break;
                    case 2:
                      e(i[0], i[1]);
                      break;
                    case 3:
                      e(i[0], i[1], i[2]);
                      break;
                    default:
                      e.apply(void 0, i);
                  }
                })(e);
              } finally {
                u(t), (a = !1);
              }
            }
          }
        }
      })('undefined' == typeof self ? (void 0 === t ? this : t) : self);
    }).call(this, i(16), i(41));
  },
  55: function (t, e, i) {
    (function (t) {
      var r = (void 0 !== t && t) || ('undefined' != typeof self && self) || window,
        n = Function.prototype.apply;
      function s(t, e) {
        (this._id = t), (this._clearFn = e);
      }
      (e.setTimeout = function () {
        return new s(n.call(setTimeout, r, arguments), clearTimeout);
      }),
        (e.setInterval = function () {
          return new s(n.call(setInterval, r, arguments), clearInterval);
        }),
        (e.clearTimeout = e.clearInterval =
          function (t) {
            t && t.close();
          }),
        (s.prototype.unref = s.prototype.ref = function () { }),
        (s.prototype.close = function () {
          this._clearFn.call(r, this._id);
        }),
        (e.enroll = function (t, e) {
          clearTimeout(t._idleTimeoutId), (t._idleTimeout = e);
        }),
        (e.unenroll = function (t) {
          clearTimeout(t._idleTimeoutId), (t._idleTimeout = -1);
        }),
        (e._unrefActive = e.active =
          function (t) {
            clearTimeout(t._idleTimeoutId);
            var e = t._idleTimeout;
            e >= 0 &&
              (t._idleTimeoutId = setTimeout(function () {
                t._onTimeout && t._onTimeout();
              }, e));
          }),
        i(29),
        (e.setImmediate =
          ('undefined' != typeof self && self.setImmediate) ||
          (void 0 !== t && t.setImmediate) ||
          (this && this.setImmediate)),
        (e.clearImmediate =
          ('undefined' != typeof self && self.clearImmediate) ||
          (void 0 !== t && t.clearImmediate) ||
          (this && this.clearImmediate));
    }).call(this, i(16));
  },
  70: function (t, e, i) {
    'use strict';
    var r = i(9),
      n = i(19),
      s = i(14);
    Object(r.b)('featured-collection', {
      cacheSelectors() {
        const t = '[data-section-id="'
          .concat(this.id, '"] ')
          .concat('[js-featured-collection="carousel"]'),
          e = '[data-section-id="'
            .concat(this.id, '"] ')
            .concat('[js-featured-collection="slide"]'),
          i = '[data-section-id="'.concat(this.id, '"] ').concat('[js-featured-collection="prev"]'),
          r = '[data-section-id="'.concat(this.id, '"] ').concat('[js-featured-collection="next"]');
        this.cache = { container: t, cells: e, nextButton: r, prevButton: i };
      },
      constructCarousel() {
        // Check if this is a product page carousel
        const container = document.querySelector(this.cache.container);
        const isProductCarousel = container && container.closest('.featured-collection') &&
          container.closest('.featured-collection').hasAttribute('data-product-carousel');

        // Set different slidesPerView values based on carousel type
        const largeViewSlides = isProductCarousel ? 1.5 : 3.5;
        const mediumViewSlides = isProductCarousel ? 1 : 2.5;
        const wideViewSlides = isProductCarousel ? 2 : 3.5;

        console.log(s.b)

        console.log('Carousel type:', isProductCarousel ? 'product carousel' : 'featured collection');
        console.log('Slides per view (large):', largeViewSlides);

        Object(n.a)(this.cache.container, {
          swiper: {
            loop: !1,
            breakpoints: {
              [s.b.medium]: { loopedSlides: mediumViewSlides, slidesPerView: mediumViewSlides },
              [s.b.large]: { loopedSlides: largeViewSlides, slidesPerView: largeViewSlides },
              [s.b.wide]: { loopedSlides: wideViewSlides, slidesPerView: wideViewSlides },
            },
            centeredSlides: !1,
            navigation: { nextEl: this.cache.nextButton, prevEl: this.cache.prevButton },
            slidesPerView: 1.2,
          },
        }).init();
      },
      onLoad() {
        this.cacheSelectors(), this.constructCarousel();
      },
    });
  },
  91: function (t, e, i) {
    'use strict';
    var r = i(9),
      n = i(15),
      s = i.n(n),
      a = i(25),
      o = i.n(a),
      l = {
        props: ['data', 'is-slider-visible'],
        data: () => ({ carousel: '' }),
        watch: {
          isSliderVisible() {
            this.visibleContainer();
          },
        },
        mounted() {
          this.constructSlider();
        },
        methods: {
          setCurrentSlide(t) {
            this.$emit('update-current-slide', t);
          },
          visibleContainer() {
            this.$refs.container.classList.add('is-visible');
          },
          constructSlider() {
            const t = this,
              e = Number(this.data.autoplay);
            let i = !1;
            0 !== e && (i = { delay: e, disableOnInteraction: !0 }),
              (this.carousel = new o.a(t.$refs.slider, {
                autoplay: i,
                loop: !0,
                effect: 'fade',
                fadeEffect: { crossFade: !0 },
                speed: 500,
                keyboard: { enabled: !0, onlyInViewport: !0 },
                spaceBetween: 1,
                pagination: {
                  el: this.$refs.pagination,
                  clickable: !0,
                  renderBullet: (t, e) => "<button class='".concat(e, "'></button>"),
                },
                on: {
                  slideChange() {
                    t.setCurrentSlide(this.realIndex);
                  },
                },
              }));
          },
        },
      },
      u = i(2),
      c = Object(u.a)(
        l,
        function () {
          var t = this,
            e = t.$createElement,
            i = t._self._c || e;
          return i('div', { ref: 'container', staticClass: 'hero-image-slider' }, [
            i('div', { ref: 'slider', staticClass: 'swiper-container hero-image-slider__slider' }, [
              i(
                'div',
                { staticClass: 'swiper-wrapper' },
                t._l(t.data.slides, function (e, r) {
                  return i(
                    'div',
                    { key: r, staticClass: 'swiper-slide hero-image-slider__slide' },
                    [
                      e.link && t.data.imageClickable
                        ? i(
                          'a',
                          {
                            staticClass: 'hero-image-slider__link',
                            attrs: { href: e.link, 'aria-label': e.largeImage.alt },
                          },
                          [
                            i('div', {
                              staticClass: 'hero-image-slider__bg-image lazyload',
                              attrs: {
                                'data-bgset':
                                  '\n              ' +
                                  e.smallImage.highResUrl +
                                  ' 720w [(max-width: 576px)] |\n              ' +
                                  e.smallImage.highResUrl +
                                  ' 980w,\n              ' +
                                  e.largeImage.highResUrl +
                                  ' 1240w,\n              ' +
                                  e.largeImage.highResUrl +
                                  ' 1680w,\n              ' +
                                  e.largeImage.highResUrl +
                                  ' 2000w,',
                                'aria-label': e.largeImage.alt,
                              },
                            }),
                          ]
                        )
                        : i('div', {
                          staticClass: 'hero-image-slider__bg-image lazyload',
                          attrs: {
                            'data-bgset':
                              '\n              ' +
                              e.smallImage.highResUrl +
                              ' 720w [(max-width: 576px)] |\n              ' +
                              e.smallImage.highResUrl +
                              ' 980w,\n              ' +
                              e.largeImage.highResUrl +
                              ' 1240w,\n              ' +
                              e.largeImage.highResUrl +
                              ' 1680w,\n              ' +
                              e.largeImage.highResUrl +
                              ' 2000w,\n            ',
                          },
                        }),
                    ]
                  );
                }),
                0
              ),
              t._v(' '),
              t.data.slides.length > 1 ? i('div', { ref: 'pagination' }) : t._e(),
            ]),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports,
      h = {
        props: ['data', 'is-slider-visible'],
        watch: {
          isSliderVisible() {
            this.visibleContainer();
          },
        },
        methods: {
          visibleContainer() {
            this.$refs.container.classList.add('is-visible');
          },
        },
      },
      d = Object(u.a)(
        h,
        function () {
          var t = this.$createElement,
            e = this._self._c || t;
          return e('div', { ref: 'container', staticClass: 'hero-split-image' }, [
            e('div', {
              staticClass: 'hero-split-image__bg-image lazyload',
              style: { backgroundImage: 'url(' + this.data.splitImage.lowResUrl + ')' },
              attrs: { 'data-bgset': this.data.splitImage.highResUrl },
            }),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports;
    function f(t) {
      if (void 0 === t)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function p(t, e) {
      (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), (t.__proto__ = e);
    }
    /*!
     * GSAP 3.2.3
     * https://greensock.com
     *
     * @license Copyright 2008-2020, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */ i(3);
    var _,
      m,
      g,
      v,
      y,
      b,
      w,
      x,
      C = { autoSleep: 120, force3D: 'auto', nullTargetWarn: 1, units: { lineHeight: '' } },
      T = { duration: 0.5, overwrite: !1, delay: 0 },
      k = 1e-8,
      O = 2 * Math.PI,
      S = O / 4,
      M = 0,
      E = Math.sqrt,
      P = Math.cos,
      z = Math.sin,
      R = function (t) {
        return 'string' == typeof t;
      },
      A = function (t) {
        return 'function' == typeof t;
      },
      D = function (t) {
        return 'number' == typeof t;
      },
      I = function (t) {
        return void 0 === t;
      },
      F = function (t) {
        return 'object' == typeof t;
      },
      L = function (t) {
        return !1 !== t;
      },
      j = function () {
        return 'undefined' != typeof window;
      },
      B = function (t) {
        return A(t) || R(t);
      },
      $ = Array.isArray,
      U = /(?:-?\.?\d|\.)+/gi,
      N = /[-+=.]*\d+[.e\-+]*\d*[e\-\+]*\d*/g,
      V = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
      Y = /[-+=.]*\d+(?:\.|e-|e)*\d*/gi,
      H = /\(([^()]+)\)/i,
      X = /[+-]=-?[\.\d]+/,
      q = /[#\-+.]*\b[a-z\d-=+%.]+/gi,
      G = {},
      J = {},
      Q = function (t) {
        return (J = xt(t, G)) && Qe;
      },
      W = function (t, e) {
        return console.warn(
          'Invalid property',
          t,
          'set to',
          e,
          'Missing plugin? gsap.registerPlugin()'
        );
      },
      Z = function (t, e) {
        return !e && console.warn(t);
      },
      K = function (t, e) {
        return (t && (G[t] = e) && J && (J[t] = e)) || G;
      },
      tt = function () {
        return 0;
      },
      et = {},
      it = [],
      rt = {},
      nt = {},
      st = {},
      at = 30,
      ot = [],
      lt = '',
      ut = function (t) {
        var e,
          i,
          r = t[0];
        if ((F(r) || A(r) || (t = [t]), !(e = (r._gsap || {}).harness))) {
          for (i = ot.length; i-- && !ot[i].targetTest(r););
          e = ot[i];
        }
        for (i = t.length; i--;)
          (t[i] && (t[i]._gsap || (t[i]._gsap = new xe(t[i], e)))) || t.splice(i, 1);
        return t;
      },
      ct = function (t) {
        return t._gsap || ut(Ht(t))[0]._gsap;
      },
      ht = function (t, e) {
        var i = t[e];
        return A(i) ? t[e]() : (I(i) && t.getAttribute(e)) || i;
      },
      dt = function (t, e) {
        return (t = t.split(',')).forEach(e) || t;
      },
      ft = function (t) {
        return Math.round(1e5 * t) / 1e5 || 0;
      },
      pt = function (t, e) {
        for (var i = e.length, r = 0; t.indexOf(e[r]) < 0 && ++r < i;);
        return r < i;
      },
      _t = function (t, e, i) {
        var r,
          n = D(t[1]),
          s = (n ? 2 : 1) + (e < 2 ? 0 : 1),
          a = t[s];
        if ((n && (a.duration = t[1]), (a.parent = i), e)) {
          for (r = a; i && !('immediateRender' in r);)
            (r = i.vars.defaults || {}), (i = L(i.vars.inherit) && i.parent);
          (a.immediateRender = L(r.immediateRender)),
            e < 2 ? (a.runBackwards = 1) : (a.startAt = t[s - 1]);
        }
        return a;
      },
      mt = function () {
        var t,
          e,
          i = it.length,
          r = it.slice(0);
        for (rt = {}, it.length = 0, t = 0; t < i; t++)
          (e = r[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
      },
      gt = function (t, e, i, r) {
        it.length && mt(), t.render(e, i, r), it.length && mt();
      },
      vt = function (t) {
        var e = parseFloat(t);
        return (e || 0 === e) && (t + '').match(q).length < 2 ? e : t;
      },
      yt = function (t) {
        return t;
      },
      bt = function (t, e) {
        for (var i in e) i in t || (t[i] = e[i]);
        return t;
      },
      wt = function (t, e) {
        for (var i in e) i in t || 'duration' === i || 'ease' === i || (t[i] = e[i]);
      },
      xt = function (t, e) {
        for (var i in e) t[i] = e[i];
        return t;
      },
      Ct = function t(e, i) {
        for (var r in i) e[r] = F(i[r]) ? t(e[r] || (e[r] = {}), i[r]) : i[r];
        return e;
      },
      Tt = function (t, e) {
        var i,
          r = {};
        for (i in t) i in e || (r[i] = t[i]);
        return r;
      },
      kt = function (t) {
        var e = t.parent || _,
          i = t.keyframes ? wt : bt;
        if (L(t.inherit)) for (; e;) i(t, e.vars.defaults), (e = e.parent);
        return t;
      },
      Ot = function (t, e, i, r) {
        void 0 === i && (i = '_first'), void 0 === r && (r = '_last');
        var n = e._prev,
          s = e._next;
        n ? (n._next = s) : t[i] === e && (t[i] = s),
          s ? (s._prev = n) : t[r] === e && (t[r] = n),
          (e._next = e._prev = e.parent = null);
      },
      St = function (t, e) {
        !t.parent || (e && !t.parent.autoRemoveChildren) || t.parent.remove(t), (t._act = 0);
      },
      Mt = function (t) {
        for (var e = t; e;) (e._dirty = 1), (e = e.parent);
        return t;
      },
      Et = function (t) {
        return t._repeat ? Pt(t._tTime, (t = t.duration() + t._rDelay)) * t : 0;
      },
      Pt = function (t, e) {
        return (t /= e) && ~~t === t ? ~~t - 1 : ~~t;
      },
      zt = function (t, e) {
        return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
      },
      Rt = function (t) {
        return (t._end = ft(t._start + (t._tDur / Math.abs(t._ts || t._pauseTS || k) || 0)));
      },
      At = function (t, e) {
        var i;
        if (
          ((e._time || (e._initted && !e._dur)) &&
            ((i = zt(t.rawTime(), e)),
              (!e._dur || Ut(0, e.totalDuration(), i) - e._tTime > k) && e.render(i, !0)),
            Mt(t)._dp && t._initted && t._time >= t._dur && t._ts)
        ) {
          if (t._dur < t.duration())
            for (i = t; i._dp;) i.rawTime() >= 0 && i.totalTime(i._tTime), (i = i._dp);
          t._zTime = -k;
        }
      },
      Dt = function (t, e, i, r) {
        return (
          e.parent && St(e),
          (e._start = ft(i + e._delay)),
          (e._end = ft(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0))),
          (function (t, e, i, r, n) {
            void 0 === i && (i = '_first'), void 0 === r && (r = '_last');
            var s,
              a = t[r];
            if (n) for (s = e[n]; a && a[n] > s;) a = a._prev;
            a ? ((e._next = a._next), (a._next = e)) : ((e._next = t[i]), (t[i] = e)),
              e._next ? (e._next._prev = e) : (t[r] = e),
              (e._prev = a),
              (e.parent = e._dp = t);
          })(t, e, '_first', '_last', t._sort ? '_start' : 0),
          (t._recent = e),
          r || At(t, e),
          t
        );
      },
      It = function (t, e, i, r) {
        return (
          Me(t, e),
          t._initted
            ? !i &&
              t._pt &&
              ((t._dur && !1 !== t.vars.lazy) || (!t._dur && t.vars.lazy)) &&
              b !== he.frame
              ? (it.push(t), (t._lazy = [e, r]), 1)
              : void 0
            : 1
        );
      },
      Ft = function (t, e, i) {
        var r = t._repeat,
          n = ft(e);
        return (
          (t._dur = n),
          (t._tDur = r ? (r < 0 ? 1e12 : ft(n * (r + 1) + t._rDelay * r)) : n),
          !i && Mt(t.parent),
          t.parent && Rt(t),
          t
        );
      },
      Lt = function (t) {
        return t instanceof Te ? Mt(t) : Ft(t, t._dur);
      },
      jt = { _start: 0, endTime: tt },
      Bt = function t(e, i) {
        var r,
          n,
          s = e.labels,
          a = e._recent || jt,
          o = e.duration() >= 1e8 ? a.endTime(!1) : e._dur;
        return R(i) && (isNaN(i) || i in s)
          ? '<' === (r = i.charAt(0)) || '>' === r
            ? ('<' === r ? a._start : a.endTime(a._repeat >= 0)) + (parseFloat(i.substr(1)) || 0)
            : (r = i.indexOf('=')) < 0
              ? (i in s || (s[i] = o), s[i])
              : ((n = +(i.charAt(r - 1) + i.substr(r + 1))),
                r > 1 ? t(e, i.substr(0, r - 1)) + n : o + n)
          : null == i
            ? o
            : +i;
      },
      $t = function (t, e) {
        return t || 0 === t ? e(t) : e;
      },
      Ut = function (t, e, i) {
        return i < t ? t : i > e ? e : i;
      },
      Nt = function (t) {
        return (t + '').substr((parseFloat(t) + '').length);
      },
      Vt = [].slice,
      Yt = function (t, e) {
        return (
          t &&
          F(t) &&
          'length' in t &&
          ((!e && !t.length) || (t.length - 1 in t && F(t[0]))) &&
          !t.nodeType &&
          t !== m
        );
      },
      Ht = function (t, e) {
        return !R(t) || e || (!g && de())
          ? $(t)
            ? (function (t, e, i) {
              return (
                void 0 === i && (i = []),
                t.forEach(function (t) {
                  var r;
                  return (R(t) && !e) || Yt(t, 1) ? (r = i).push.apply(r, Ht(t)) : i.push(t);
                }) || i
              );
            })(t, e)
            : Yt(t)
              ? Vt.call(t, 0)
              : t
                ? [t]
                : []
          : Vt.call(v.querySelectorAll(t), 0);
      },
      Xt = function (t) {
        return t.sort(function () {
          return 0.5 - Math.random();
        });
      },
      qt = function (t) {
        if (A(t)) return t;
        var e = F(t) ? t : { each: t },
          i = ge(e.ease),
          r = e.from || 0,
          n = parseFloat(e.base) || 0,
          s = {},
          a = r > 0 && r < 1,
          o = isNaN(r) || a,
          l = e.axis,
          u = r,
          c = r;
        return (
          R(r)
            ? (u = c = { center: 0.5, edges: 0.5, end: 1 }[r] || 0)
            : !a && o && ((u = r[0]), (c = r[1])),
          function (t, a, h) {
            var d,
              f,
              p,
              _,
              m,
              g,
              v,
              y,
              b,
              w = (h || e).length,
              x = s[w];
            if (!x) {
              if (!(b = 'auto' === e.grid ? 0 : (e.grid || [1, 1e8])[1])) {
                for (v = -1e8; v < (v = h[b++].getBoundingClientRect().left) && b < w;);
                b--;
              }
              for (
                x = s[w] = [],
                d = o ? Math.min(b, w) * u - 0.5 : r % b,
                f = o ? (w * c) / b - 0.5 : (r / b) | 0,
                v = 0,
                y = 1e8,
                g = 0;
                g < w;
                g++
              )
                (p = (g % b) - d),
                  (_ = f - ((g / b) | 0)),
                  (x[g] = m = l ? Math.abs('y' === l ? _ : p) : E(p * p + _ * _)),
                  m > v && (v = m),
                  m < y && (y = m);
              'random' === r && Xt(x),
                (x.max = v - y),
                (x.min = y),
                (x.v = w =
                  (parseFloat(e.amount) ||
                    parseFloat(e.each) *
                    (b > w ? w - 1 : l ? ('y' === l ? w / b : b) : Math.max(b, w / b)) ||
                    0) * ('edges' === r ? -1 : 1)),
                (x.b = w < 0 ? n - w : n),
                (x.u = Nt(e.amount || e.each) || 0),
                (i = i && w < 0 ? me(i) : i);
            }
            return (w = (x[t] - x.min) / x.max || 0), ft(x.b + (i ? i(w) : w) * x.v) + x.u;
          }
        );
      },
      Gt = function (t) {
        var e = t < 1 ? Math.pow(10, (t + '').length - 2) : 1;
        return function (i) {
          return ~~(Math.round(parseFloat(i) / t) * t * e) / e + (D(i) ? 0 : Nt(i));
        };
      },
      Jt = function (t, e) {
        var i,
          r,
          n = $(t);
        return (
          !n &&
          F(t) &&
          ((i = n = t.radius || 1e8),
            t.values ? ((t = Ht(t.values)), (r = !D(t[0])) && (i *= i)) : (t = Gt(t.increment))),
          $t(
            e,
            n
              ? A(t)
                ? function (e) {
                  return (r = t(e)), Math.abs(r - e) <= i ? r : e;
                }
                : function (e) {
                  for (
                    var n,
                    s,
                    a = parseFloat(r ? e.x : e),
                    o = parseFloat(r ? e.y : 0),
                    l = 1e8,
                    u = 0,
                    c = t.length;
                    c--;

                  )
                    (n = r ? (n = t[c].x - a) * n + (s = t[c].y - o) * s : Math.abs(t[c] - a)) <
                      l && ((l = n), (u = c));
                  return (u = !i || l <= i ? t[u] : e), r || u === e || D(e) ? u : u + Nt(e);
                }
              : Gt(t)
          )
        );
      },
      Qt = function (t, e, i, r) {
        return $t($(t) ? !e : !0 === i ? !!(i = 0) : !r, function () {
          return $(t)
            ? t[~~(Math.random() * t.length)]
            : (i = i || 1e-5) &&
            (r = i < 1 ? Math.pow(10, (i + '').length - 2) : 1) &&
            ~~(Math.round((t + Math.random() * (e - t)) / i) * i * r) / r;
        });
      },
      Wt = function (t, e, i) {
        return $t(i, function (i) {
          return t[~~e(i)];
        });
      },
      Zt = function (t) {
        for (var e, i, r, n, s = 0, a = ''; ~(e = t.indexOf('random(', s));)
          (r = t.indexOf(')', e)),
            (n = '[' === t.charAt(e + 7)),
            (i = t.substr(e + 7, r - e - 7).match(n ? q : U)),
            (a += t.substr(s, e - s) + Qt(n ? i : +i[0], +i[1], +i[2] || 1e-5)),
            (s = r + 1);
        return a + t.substr(s, t.length - s);
      },
      Kt = function (t, e, i, r, n) {
        var s = e - t,
          a = r - i;
        return $t(n, function (e) {
          return i + ((e - t) / s) * a;
        });
      },
      te = function (t, e, i) {
        var r,
          n,
          s,
          a = t.labels,
          o = 1e8;
        for (r in a) (n = a[r] - e) < 0 == !!i && n && o > (n = Math.abs(n)) && ((s = r), (o = n));
        return s;
      },
      ee = function (t, e, i) {
        var r,
          n,
          s = t.vars,
          a = s[e];
        if (a)
          return (
            (r = s[e + 'Params']),
            (n = s.callbackScope || t),
            i && it.length && mt(),
            r ? a.apply(n, r) : a.call(n)
          );
      },
      ie = function (t) {
        return St(t), t.progress() < 1 && ee(t, 'onInterrupt'), t;
      },
      re = {
        aqua: [0, 255, 255],
        lime: [0, 255, 0],
        silver: [192, 192, 192],
        black: [0, 0, 0],
        maroon: [128, 0, 0],
        teal: [0, 128, 128],
        blue: [0, 0, 255],
        navy: [0, 0, 128],
        white: [255, 255, 255],
        olive: [128, 128, 0],
        yellow: [255, 255, 0],
        orange: [255, 165, 0],
        gray: [128, 128, 128],
        purple: [128, 0, 128],
        green: [0, 128, 0],
        red: [255, 0, 0],
        pink: [255, 192, 203],
        cyan: [0, 255, 255],
        transparent: [255, 255, 255, 0],
      },
      ne = function (t, e, i) {
        return (
          (255 *
            (6 * (t = t < 0 ? t + 1 : t > 1 ? t - 1 : t) < 1
              ? e + (i - e) * t * 6
              : t < 0.5
                ? i
                : 3 * t < 2
                  ? e + (i - e) * (2 / 3 - t) * 6
                  : e) +
            0.5) |
          0
        );
      },
      se = function (t, e, i) {
        var r,
          n,
          s,
          a,
          o,
          l,
          u,
          c,
          h,
          d,
          f = t ? (D(t) ? [t >> 16, (t >> 8) & 255, 255 & t] : 0) : re.black;
        if (!f) {
          if ((',' === t.substr(-1) && (t = t.substr(0, t.length - 1)), re[t])) f = re[t];
          else if ('#' === t.charAt(0))
            4 === t.length &&
              (t = '#' + (r = t.charAt(1)) + r + (n = t.charAt(2)) + n + (s = t.charAt(3)) + s),
              (f = [(t = parseInt(t.substr(1), 16)) >> 16, (t >> 8) & 255, 255 & t]);
          else if ('hsl' === t.substr(0, 3))
            if (((f = d = t.match(U)), e)) {
              if (~t.indexOf('=')) return (f = t.match(N)), i && f.length < 4 && (f[3] = 1), f;
            } else
              (a = (+f[0] % 360) / 360),
                (o = +f[1] / 100),
                (r = 2 * (l = +f[2] / 100) - (n = l <= 0.5 ? l * (o + 1) : l + o - l * o)),
                f.length > 3 && (f[3] *= 1),
                (f[0] = ne(a + 1 / 3, r, n)),
                (f[1] = ne(a, r, n)),
                (f[2] = ne(a - 1 / 3, r, n));
          else f = t.match(U) || re.transparent;
          f = f.map(Number);
        }
        return (
          e &&
          !d &&
          ((r = f[0] / 255),
            (n = f[1] / 255),
            (s = f[2] / 255),
            (l = ((u = Math.max(r, n, s)) + (c = Math.min(r, n, s))) / 2),
            u === c
              ? (a = o = 0)
              : ((h = u - c),
                (o = l > 0.5 ? h / (2 - u - c) : h / (u + c)),
                (a =
                  u === r
                    ? (n - s) / h + (n < s ? 6 : 0)
                    : u === n
                      ? (s - r) / h + 2
                      : (r - n) / h + 4),
                (a *= 60)),
            (f[0] = ~~(a + 0.5)),
            (f[1] = ~~(100 * o + 0.5)),
            (f[2] = ~~(100 * l + 0.5))),
          i && f.length < 4 && (f[3] = 1),
          f
        );
      },
      ae = function (t) {
        var e = [],
          i = [],
          r = -1;
        return (
          t.split(le).forEach(function (t) {
            var n = t.match(V) || [];
            e.push.apply(e, n), i.push((r += n.length + 1));
          }),
          (e.c = i),
          e
        );
      },
      oe = function (t, e, i) {
        var r,
          n,
          s,
          a,
          o = '',
          l = (t + o).match(le),
          u = e ? 'hsla(' : 'rgba(',
          c = 0;
        if (!l) return t;
        if (
          ((l = l.map(function (t) {
            return (
              (t = se(t, e, 1)) &&
              u + (e ? t[0] + ',' + t[1] + '%,' + t[2] + '%,' + t[3] : t.join(',')) + ')'
            );
          })),
            i && ((s = ae(t)), (r = i.c).join(o) !== s.c.join(o)))
        )
          for (a = (n = t.replace(le, '1').split(V)).length - 1; c < a; c++)
            o +=
              n[c] +
              (~r.indexOf(c)
                ? l.shift() || u + '0,0,0,0)'
                : (s.length ? s : l.length ? l : i).shift());
        if (!n) for (a = (n = t.split(le)).length - 1; c < a; c++) o += n[c] + l[c];
        return o + n[a];
      },
      le = (function () {
        var t,
          e = '(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b';
        for (t in re) e += '|' + t + '\\b';
        return new RegExp(e + ')', 'gi');
      })(),
      ue = /hsl[a]?\(/,
      ce = function (t) {
        var e,
          i = t.join(' ');
        if (((le.lastIndex = 0), le.test(i)))
          return (e = ue.test(i)), (t[1] = oe(t[1], e)), (t[0] = oe(t[0], e, ae(t[1]))), !0;
      },
      he = (function () {
        var t,
          e,
          i,
          r,
          n = Date.now,
          s = 500,
          a = 33,
          o = n(),
          l = o,
          u = 1 / 240,
          c = u,
          h = [],
          d = function i(d) {
            var f,
              p,
              _ = n() - l,
              m = !0 === d;
            _ > s && (o += _ - a),
              (l += _),
              (r.time = (l - o) / 1e3),
              ((f = r.time - c) > 0 || m) &&
              (r.frame++, (c += f + (f >= u ? 0.004 : u - f)), (p = 1)),
              m || (t = e(i)),
              p &&
              h.forEach(function (t) {
                return t(r.time, _, r.frame, d);
              });
          };
        return (r = {
          time: 0,
          frame: 0,
          tick: function () {
            d(!0);
          },
          wake: function () {
            y &&
              (!g &&
                j() &&
                ((m = g = window),
                  (v = m.document || {}),
                  (G.gsap = Qe),
                  (m.gsapVersions || (m.gsapVersions = [])).push(Qe.version),
                  Q(J || m.GreenSockGlobals || (!m.gsap && m) || {}),
                  (i = m.requestAnimationFrame)),
                t && r.sleep(),
                (e =
                  i ||
                  function (t) {
                    return setTimeout(t, (1e3 * (c - r.time) + 1) | 0);
                  }),
                (x = 1),
                d(2));
          },
          sleep: function () {
            (i ? m.cancelAnimationFrame : clearTimeout)(t), (x = 0), (e = tt);
          },
          lagSmoothing: function (t, e) {
            (s = t || 1e8), (a = Math.min(e, s, 0));
          },
          fps: function (t) {
            (u = 1 / (t || 240)), (c = r.time + u);
          },
          add: function (t) {
            h.indexOf(t) < 0 && h.push(t), de();
          },
          remove: function (t) {
            var e;
            ~(e = h.indexOf(t)) && h.splice(e, 1);
          },
          _listeners: h,
        });
      })(),
      de = function () {
        return !x && he.wake();
      },
      fe = {},
      pe = /^[\d.\-M][\d.\-,\s]/,
      _e = /["']/g,
      me = function (t) {
        return function (e) {
          return 1 - t(1 - e);
        };
      },
      ge = function (t, e) {
        return (
          (t &&
            (A(t)
              ? t
              : fe[t] ||
              (function (t) {
                var e = (t + '').split('('),
                  i = fe[e[0]];
                return i && e.length > 1 && i.config
                  ? i.config.apply(
                    null,
                    ~t.indexOf('{')
                      ? [
                        (function (t) {
                          for (
                            var e,
                            i,
                            r,
                            n = {},
                            s = t.substr(1, t.length - 3).split(':'),
                            a = s[0],
                            o = 1,
                            l = s.length;
                            o < l;
                            o++
                          )
                            (i = s[o]),
                              (e = o !== l - 1 ? i.lastIndexOf(',') : i.length),
                              (r = i.substr(0, e)),
                              (n[a] = isNaN(r) ? r.replace(_e, '').trim() : +r),
                              (a = i.substr(e + 1).trim());
                          return n;
                        })(e[1]),
                      ]
                      : H.exec(t)[1].split(',').map(vt)
                  )
                  : fe._CE && pe.test(t)
                    ? fe._CE('', t)
                    : i;
              })(t))) ||
          e
        );
      },
      ve = function (t, e, i, r) {
        void 0 === i &&
          (i = function (t) {
            return 1 - e(1 - t);
          }),
          void 0 === r &&
          (r = function (t) {
            return t < 0.5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2;
          });
        var n,
          s = { easeIn: e, easeOut: i, easeInOut: r };
        return (
          dt(t, function (t) {
            for (var e in ((fe[t] = G[t] = s), (fe[(n = t.toLowerCase())] = i), s))
              fe[n + ('easeIn' === e ? '.in' : 'easeOut' === e ? '.out' : '.inOut')] = fe[
                t + '.' + e
              ] = s[e];
          }),
          s
        );
      },
      ye = function (t) {
        return function (e) {
          return e < 0.5 ? (1 - t(1 - 2 * e)) / 2 : 0.5 + t(2 * (e - 0.5)) / 2;
        };
      },
      be = function t(e, i, r) {
        var n = i >= 1 ? i : 1,
          s = (r || (e ? 0.3 : 0.45)) / (i < 1 ? i : 1),
          a = (s / O) * (Math.asin(1 / n) || 0),
          o = function (t) {
            return 1 === t ? 1 : n * Math.pow(2, -10 * t) * z((t - a) * s) + 1;
          },
          l =
            'out' === e
              ? o
              : 'in' === e
                ? function (t) {
                  return 1 - o(1 - t);
                }
                : ye(o);
        return (
          (s = O / s),
          (l.config = function (i, r) {
            return t(e, i, r);
          }),
          l
        );
      },
      we = function t(e, i) {
        void 0 === i && (i = 1.70158);
        var r = function (t) {
          return t ? --t * t * ((i + 1) * t + i) + 1 : 0;
        },
          n =
            'out' === e
              ? r
              : 'in' === e
                ? function (t) {
                  return 1 - r(1 - t);
                }
                : ye(r);
        return (
          (n.config = function (i) {
            return t(e, i);
          }),
          n
        );
      };
    dt('Linear,Quad,Cubic,Quart,Quint,Strong', function (t, e) {
      var i = e < 5 ? e + 1 : e;
      ve(
        t + ',Power' + (i - 1),
        e
          ? function (t) {
            return Math.pow(t, i);
          }
          : function (t) {
            return t;
          },
        function (t) {
          return 1 - Math.pow(1 - t, i);
        },
        function (t) {
          return t < 0.5 ? Math.pow(2 * t, i) / 2 : 1 - Math.pow(2 * (1 - t), i) / 2;
        }
      );
    }),
      (fe.Linear.easeNone = fe.none = fe.Linear.easeIn),
      ve('Elastic', be('in'), be('out'), be()),
      (function (t, e) {
        var i = function (i) {
          return i < 0.36363636363636365
            ? t * i * i
            : i < 0.7272727272727273
              ? t * Math.pow(i - 1.5 / e, 2) + 0.75
              : i < 0.9090909090909092
                ? t * (i -= 2.25 / e) * i + 0.9375
                : t * Math.pow(i - 2.625 / e, 2) + 0.984375;
        };
        ve(
          'Bounce',
          function (t) {
            return 1 - i(1 - t);
          },
          i
        );
      })(7.5625, 2.75),
      ve('Expo', function (t) {
        return t ? Math.pow(2, 10 * (t - 1)) : 0;
      }),
      ve('Circ', function (t) {
        return -(E(1 - t * t) - 1);
      }),
      ve('Sine', function (t) {
        return 1 - P(t * S);
      }),
      ve('Back', we('in'), we('out'), we()),
      (fe.SteppedEase =
        fe.steps =
        G.SteppedEase =
        {
          config: function (t, e) {
            void 0 === t && (t = 1);
            var i = 1 / t,
              r = t + (e ? 0 : 1),
              n = e ? 1 : 0;
            return function (t) {
              return (((r * Ut(0, 0.99999999, t)) | 0) + n) * i;
            };
          },
        }),
      (T.ease = fe['quad.out']),
      dt('onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt', function (t) {
        return (lt += t + ',' + t + 'Params,');
      });
    var xe = function (t, e) {
      (this.id = M++),
        (t._gsap = this),
        (this.target = t),
        (this.harness = e),
        (this.get = e ? e.get : ht),
        (this.set = e ? e.getSetter : Le);
    },
      Ce = (function () {
        function t(t, e) {
          var i = t.parent || _;
          (this.vars = t),
            (this._delay = +t.delay || 0),
            (this._repeat = t.repeat || 0) &&
            ((this._rDelay = t.repeatDelay || 0), (this._yoyo = !!t.yoyo || !!t.yoyoEase)),
            (this._ts = t.reversed ? -1 : 1),
            Ft(this, +t.duration, 1),
            (this.data = t.data),
            x || he.wake(),
            i && Dt(i, this, e || 0 === e ? e : i._time, 1),
            t.paused && this.paused(!0);
        }
        var e = t.prototype;
        return (
          (e.delay = function (t) {
            return t || 0 === t ? ((this._delay = t), this) : this._delay;
          }),
          (e.duration = function (t) {
            return arguments.length ? Ft(this, t) : this.totalDuration() && this._dur;
          }),
          (e.totalDuration = function (t) {
            return arguments.length
              ? ((this._dirty = 0),
                Ft(
                  this,
                  this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1)
                ))
              : this._tDur;
          }),
          (e.totalTime = function (t, e) {
            if ((de(), !arguments.length)) return this._tTime;
            var i = this.parent || this._dp;
            if (i && i.smoothChildTiming && this._ts) {
              for (
                this._start = ft(
                  i._time -
                  (this._ts > 0
                    ? t / this._ts
                    : ((this._dirty ? this.totalDuration() : this._tDur) - t) / -this._ts)
                ),
                Rt(this),
                i._dirty || Mt(i);
                i.parent;

              )
                i.parent._time !==
                  i._start +
                  (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) &&
                  i.totalTime(i._tTime, !0),
                  (i = i.parent);
              !this.parent &&
                this._dp.autoRemoveChildren &&
                Dt(this._dp, this, this._start - this._delay);
            }
            return (
              (this._tTime === t && (this._dur || e) && Math.abs(this._zTime) !== k) ||
              (this._ts || (this._pTime = t), gt(this, t, e)),
              this
            );
          }),
          (e.time = function (t, e) {
            return arguments.length
              ? this.totalTime(
                Math.min(this.totalDuration(), t + Et(this)) % this._dur || (t ? this._dur : 0),
                e
              )
              : this._time;
          }),
          (e.totalProgress = function (t, e) {
            return arguments.length
              ? this.totalTime(this.totalDuration() * t, e)
              : this.totalDuration()
                ? Math.min(1, this._tTime / this._tDur)
                : this.ratio;
          }),
          (e.progress = function (t, e) {
            return arguments.length
              ? this.totalTime(
                this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + Et(this),
                e
              )
              : this.duration()
                ? Math.min(1, this._time / this._dur)
                : this.ratio;
          }),
          (e.iteration = function (t, e) {
            var i = this.duration() + this._rDelay;
            return arguments.length
              ? this.totalTime(this._time + (t - 1) * i, e)
              : this._repeat
                ? Pt(this._tTime, i) + 1
                : 1;
          }),
          (e.timeScale = function (t) {
            if (!arguments.length) return this._ts || this._pauseTS || 0;
            if (null !== this._pauseTS) return (this._pauseTS = t), this;
            var e = this.parent && this._ts ? zt(this.parent._time, this) : this._tTime;
            return (
              (this._ts = t),
              (function (t) {
                for (var e = t.parent; e && e.parent;)
                  (e._dirty = 1), e.totalDuration(), (e = e.parent);
                return t;
              })(this.totalTime(e, !0))
            );
          }),
          (e.paused = function (t) {
            var e = !this._ts;
            return arguments.length
              ? (e !== t &&
                (t
                  ? ((this._pauseTS = this._ts),
                    (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime())),
                    (this._ts = this._act = 0))
                  : (de(),
                    (this._ts = this._pauseTS || 1),
                    (this._pauseTS = null),
                    this.totalTime(
                      this.parent && !this.parent.smoothChildTiming
                        ? this.rawTime()
                        : this._tTime || this._pTime,
                      1 === this.progress() && (this._tTime -= k) && Math.abs(this._zTime) !== k
                    ))),
                this)
              : e;
          }),
          (e.startTime = function (t) {
            return arguments.length
              ? (this.parent && this.parent._sort && Dt(this.parent, this, t - this._delay), this)
              : this._start;
          }),
          (e.endTime = function (t) {
            return (
              this._start + (L(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts)
            );
          }),
          (e.rawTime = function (t) {
            var e = this.parent || this._dp;
            return e
              ? t && (!this._ts || (this._repeat && this._time && this.totalProgress() < 1))
                ? this._tTime % (this._dur + this._rDelay)
                : this._ts
                  ? zt(e.rawTime(t), this)
                  : this._tTime
              : this._tTime;
          }),
          (e.repeat = function (t) {
            return arguments.length ? ((this._repeat = t), Lt(this)) : this._repeat;
          }),
          (e.repeatDelay = function (t) {
            return arguments.length ? ((this._rDelay = t), Lt(this)) : this._rDelay;
          }),
          (e.yoyo = function (t) {
            return arguments.length ? ((this._yoyo = t), this) : this._yoyo;
          }),
          (e.seek = function (t, e) {
            return this.totalTime(Bt(this, t), L(e));
          }),
          (e.restart = function (t, e) {
            return this.play().totalTime(t ? -this._delay : 0, L(e));
          }),
          (e.play = function (t, e) {
            return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
          }),
          (e.reverse = function (t, e) {
            return (
              null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1)
            );
          }),
          (e.pause = function (t, e) {
            return null != t && this.seek(t, e), this.paused(!0);
          }),
          (e.resume = function () {
            return this.paused(!1);
          }),
          (e.reversed = function (t) {
            var e = this._ts || this._pauseTS || 0;
            return arguments.length
              ? (t !== this.reversed() &&
                ((this[null === this._pauseTS ? '_ts' : '_pauseTS'] = Math.abs(e) * (t ? -1 : 1)),
                  this.totalTime(this._tTime, !0)),
                this)
              : e < 0;
          }),
          (e.invalidate = function () {
            return (this._initted = 0), (this._zTime = -k), this;
          }),
          (e.isActive = function (t) {
            var e,
              i = this.parent || this._dp,
              r = this._start;
            return !(
              i &&
              !(
                this._ts &&
                (this._initted || !t) &&
                i.isActive(t) &&
                (e = i.rawTime(!0)) >= r &&
                e < this.endTime(!0) - k
              )
            );
          }),
          (e.eventCallback = function (t, e, i) {
            var r = this.vars;
            return arguments.length > 1
              ? (e
                ? ((r[t] = e),
                  i && (r[t + 'Params'] = i),
                  'onUpdate' === t && (this._onUpdate = e))
                : delete r[t],
                this)
              : r[t];
          }),
          (e.then = function (t) {
            var e = this;
            return new Promise(function (i) {
              var r = A(t) ? t : yt,
                n = function () {
                  var t = e.then;
                  (e.then = null),
                    A(r) && (r = r(e)) && (r.then || r === e) && (e.then = t),
                    i(r),
                    (e.then = t);
                };
              (e._initted && 1 === e.totalProgress() && e._ts >= 0) || (!e._tTime && e._ts < 0)
                ? n()
                : (e._prom = n);
            });
          }),
          (e.kill = function () {
            ie(this);
          }),
          t
        );
      })();
    bt(Ce.prototype, {
      _time: 0,
      _start: 0,
      _end: 0,
      _tTime: 0,
      _tDur: 0,
      _dirty: 0,
      _repeat: 0,
      _yoyo: !1,
      parent: null,
      _initted: !1,
      _rDelay: 0,
      _ts: 1,
      _dp: 0,
      ratio: 0,
      _zTime: -k,
      _prom: 0,
      _pauseTS: null,
    });
    var Te = (function (t) {
      function e(e, i) {
        var r;
        return (
          void 0 === e && (e = {}),
          ((r = t.call(this, e, i) || this).labels = {}),
          (r.smoothChildTiming = !!e.smoothChildTiming),
          (r.autoRemoveChildren = !!e.autoRemoveChildren),
          (r._sort = L(e.sortChildren)),
          r.parent && At(r.parent, f(r)),
          r
        );
      }
      p(e, t);
      var i = e.prototype;
      return (
        (i.to = function (t, e, i) {
          return new Re(t, _t(arguments, 0, this), Bt(this, D(e) ? arguments[3] : i)), this;
        }),
        (i.from = function (t, e, i) {
          return new Re(t, _t(arguments, 1, this), Bt(this, D(e) ? arguments[3] : i)), this;
        }),
        (i.fromTo = function (t, e, i, r) {
          return new Re(t, _t(arguments, 2, this), Bt(this, D(e) ? arguments[4] : r)), this;
        }),
        (i.set = function (t, e, i) {
          return (
            (e.duration = 0),
            (e.parent = this),
            kt(e).repeatDelay || (e.repeat = 0),
            (e.immediateRender = !!e.immediateRender),
            new Re(t, e, Bt(this, i), 1),
            this
          );
        }),
        (i.call = function (t, e, i) {
          return Dt(this, Re.delayedCall(0, t, e), Bt(this, i));
        }),
        (i.staggerTo = function (t, e, i, r, n, s, a) {
          return (
            (i.duration = e),
            (i.stagger = i.stagger || r),
            (i.onComplete = s),
            (i.onCompleteParams = a),
            (i.parent = this),
            new Re(t, i, Bt(this, n)),
            this
          );
        }),
        (i.staggerFrom = function (t, e, i, r, n, s, a) {
          return (
            (i.runBackwards = 1),
            (kt(i).immediateRender = L(i.immediateRender)),
            this.staggerTo(t, e, i, r, n, s, a)
          );
        }),
        (i.staggerFromTo = function (t, e, i, r, n, s, a, o) {
          return (
            (r.startAt = i),
            (kt(r).immediateRender = L(r.immediateRender)),
            this.staggerTo(t, e, r, n, s, a, o)
          );
        }),
        (i.render = function (t, e, i) {
          var r,
            n,
            s,
            a,
            o,
            l,
            u,
            c,
            h,
            d,
            f,
            p,
            m = this._time,
            g = this._dirty ? this.totalDuration() : this._tDur,
            v = this._dur,
            y = this !== _ && t > g - k && t >= 0 ? g : t < k ? 0 : t,
            b = this._zTime < 0 != t < 0 && (this._initted || !v);
          if (y !== this._tTime || i || b) {
            if (
              (m !== this._time && v && ((y += this._time - m), (t += this._time - m)),
                (r = y),
                (h = this._start),
                (l = !(c = this._ts)),
                b && (v || (m = this._zTime), (!t && e) || (this._zTime = t)),
                this._repeat &&
                ((f = this._yoyo),
                  (o = v + this._rDelay),
                  ((r = ft(y % o)) > v || g === y) && (r = v),
                  (a = ~~(y / o)) && a === y / o && ((r = v), a--),
                  f && 1 & a && ((r = v - r), (p = 1)),
                  a !== (d = Pt(this._tTime, o)) && !this._lock))
            ) {
              var w = f && 1 & d,
                x = w === (f && 1 & a);
              if (
                (a < d && (w = !w),
                  (m = w ? 0 : v),
                  (this._lock = 1),
                  (this.render(m, e, !v)._lock = 0),
                  !e && this.parent && ee(this, 'onRepeat'),
                  this.vars.repeatRefresh && !p && (this.invalidate()._lock = 1),
                  m !== this._time || l !== !this._ts)
              )
                return this;
              if (
                (x &&
                  ((this._lock = 2),
                    (m = w ? v + 1e-4 : -1e-4),
                    this.render(m, !0),
                    this.vars.repeatRefresh && !p && this.invalidate()),
                  (this._lock = 0),
                  !this._ts && !l)
              )
                return this;
            }
            if (
              (this._hasPause &&
                !this._forcing &&
                this._lock < 2 &&
                (u = (function (t, e, i) {
                  var r;
                  if (i > e)
                    for (r = t._first; r && r._start <= i;) {
                      if (!r._dur && 'isPause' === r.data && r._start > e) return r;
                      r = r._next;
                    }
                  else
                    for (r = t._last; r && r._start >= i;) {
                      if (!r._dur && 'isPause' === r.data && r._start < e) return r;
                      r = r._prev;
                    }
                })(this, ft(m), ft(r))) &&
                (y -= r - (r = u._start)),
                (this._tTime = y),
                (this._time = r),
                (this._act = !c),
                this._initted ||
                ((this._onUpdate = this.vars.onUpdate), (this._initted = 1), (this._zTime = t)),
                m || !r || e || ee(this, 'onStart'),
                r >= m && t >= 0)
            )
              for (n = this._first; n;) {
                if (((s = n._next), (n._act || r >= n._start) && n._ts && u !== n)) {
                  if (n.parent !== this) return this.render(t, e, i);
                  if (
                    (n.render(
                      n._ts > 0
                        ? (r - n._start) * n._ts
                        : (n._dirty ? n.totalDuration() : n._tDur) + (r - n._start) * n._ts,
                      e,
                      i
                    ),
                      r !== this._time || (!this._ts && !l))
                  ) {
                    (u = 0), s && (y += this._zTime = -k);
                    break;
                  }
                }
                n = s;
              }
            else {
              n = this._last;
              for (var C = t < 0 ? t : r; n;) {
                if (((s = n._prev), (n._act || C <= n._end) && n._ts && u !== n)) {
                  if (n.parent !== this) return this.render(t, e, i);
                  if (
                    (n.render(
                      n._ts > 0
                        ? (C - n._start) * n._ts
                        : (n._dirty ? n.totalDuration() : n._tDur) + (C - n._start) * n._ts,
                      e,
                      i
                    ),
                      r !== this._time || (!this._ts && !l))
                  ) {
                    (u = 0), s && (y += this._zTime = C ? -k : k);
                    break;
                  }
                }
                n = s;
              }
            }
            if (
              u &&
              !e &&
              (this.pause(), (u.render(r >= m ? 0 : -k)._zTime = r >= m ? 1 : -1), this._ts)
            )
              return (this._start = h), Rt(this), this.render(t, e, i);
            this._onUpdate && !e && ee(this, 'onUpdate', !0),
              ((y === g && g >= this.totalDuration()) || (!y && this._ts < 0)) &&
              ((h !== this._start && Math.abs(c) === Math.abs(this._ts)) ||
                ((t || !v) && ((t && this._ts > 0) || (!y && this._ts < 0)) && St(this, 1),
                  e ||
                  (t < 0 && !m) ||
                  (ee(this, y === g ? 'onComplete' : 'onReverseComplete', !0),
                    this._prom && this._prom())));
          }
          return this;
        }),
        (i.add = function (t, e) {
          var i = this;
          if ((D(e) || (e = Bt(this, e)), !(t instanceof Ce))) {
            if ($(t))
              return (
                t.forEach(function (t) {
                  return i.add(t, e);
                }),
                Mt(this)
              );
            if (R(t)) return this.addLabel(t, e);
            if (!A(t)) return this;
            t = Re.delayedCall(0, t);
          }
          return this !== t ? Dt(this, t, e) : this;
        }),
        (i.getChildren = function (t, e, i, r) {
          void 0 === t && (t = !0),
            void 0 === e && (e = !0),
            void 0 === i && (i = !0),
            void 0 === r && (r = -1e8);
          for (var n = [], s = this._first; s;)
            s._start >= r &&
              (s instanceof Re
                ? e && n.push(s)
                : (i && n.push(s), t && n.push.apply(n, s.getChildren(!0, e, i)))),
              (s = s._next);
          return n;
        }),
        (i.getById = function (t) {
          for (var e = this.getChildren(1, 1, 1), i = e.length; i--;)
            if (e[i].vars.id === t) return e[i];
        }),
        (i.remove = function (t) {
          return R(t)
            ? this.removeLabel(t)
            : A(t)
              ? this.killTweensOf(t)
              : (Ot(this, t), t === this._recent && (this._recent = this._last), Mt(this));
        }),
        (i.totalTime = function (e, i) {
          return arguments.length
            ? ((this._forcing = 1),
              this.parent ||
              this._dp ||
              !this._ts ||
              (this._start = ft(
                he.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts)
              )),
              t.prototype.totalTime.call(this, e, i),
              (this._forcing = 0),
              this)
            : this._tTime;
        }),
        (i.addLabel = function (t, e) {
          return (this.labels[t] = Bt(this, e)), this;
        }),
        (i.removeLabel = function (t) {
          return delete this.labels[t], this;
        }),
        (i.addPause = function (t, e, i) {
          var r = Re.delayedCall(0, e || tt, i);
          return (r.data = 'isPause'), (this._hasPause = 1), Dt(this, r, Bt(this, t));
        }),
        (i.removePause = function (t) {
          var e = this._first;
          for (t = Bt(this, t); e;) e._start === t && 'isPause' === e.data && St(e), (e = e._next);
        }),
        (i.killTweensOf = function (t, e, i) {
          for (var r = this.getTweensOf(t, i), n = r.length; n--;) ke !== r[n] && r[n].kill(t, e);
          return this;
        }),
        (i.getTweensOf = function (t, e) {
          for (var i, r = [], n = Ht(t), s = this._first; s;)
            s instanceof Re
              ? !pt(s._targets, n) || (e && !s.isActive('started' === e)) || r.push(s)
              : (i = s.getTweensOf(n, e)).length && r.push.apply(r, i),
              (s = s._next);
          return r;
        }),
        (i.tweenTo = function (t, e) {
          e = e || {};
          var i = this,
            r = Bt(i, t),
            n = e,
            s = n.startAt,
            a = n.onStart,
            o = n.onStartParams,
            l = Re.to(
              i,
              bt(e, {
                ease: 'none',
                lazy: !1,
                time: r,
                duration:
                  e.duration ||
                  Math.abs(r - (s && 'time' in s ? s.time : i._time)) / i.timeScale() ||
                  k,
                onStart: function () {
                  i.pause();
                  var t = e.duration || Math.abs(r - i._time) / i.timeScale();
                  l._dur !== t && Ft(l, t).render(l._time, !0, !0), a && a.apply(l, o || []);
                },
              })
            );
          return l;
        }),
        (i.tweenFromTo = function (t, e, i) {
          return this.tweenTo(e, bt({ startAt: { time: Bt(this, t) } }, i));
        }),
        (i.recent = function () {
          return this._recent;
        }),
        (i.nextLabel = function (t) {
          return void 0 === t && (t = this._time), te(this, Bt(this, t));
        }),
        (i.previousLabel = function (t) {
          return void 0 === t && (t = this._time), te(this, Bt(this, t), 1);
        }),
        (i.currentLabel = function (t) {
          return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + k);
        }),
        (i.shiftChildren = function (t, e, i) {
          void 0 === i && (i = 0);
          for (var r, n = this._first, s = this.labels; n;)
            n._start >= i && (n._start += t), (n = n._next);
          if (e) for (r in s) s[r] >= i && (s[r] += t);
          return Mt(this);
        }),
        (i.invalidate = function () {
          var e = this._first;
          for (this._lock = 0; e;) e.invalidate(), (e = e._next);
          return t.prototype.invalidate.call(this);
        }),
        (i.clear = function (t) {
          void 0 === t && (t = !0);
          for (var e, i = this._first; i;) (e = i._next), this.remove(i), (i = e);
          return (this._time = this._tTime = 0), t && (this.labels = {}), Mt(this);
        }),
        (i.totalDuration = function (t) {
          var e,
            i,
            r,
            n,
            s = 0,
            a = this._last,
            o = 1e8;
          if (arguments.length)
            return this._repeat < 0 ? this : this.timeScale(this.totalDuration() / t);
          if (this._dirty) {
            for (n = this.parent; a;)
              (e = a._prev),
                a._dirty && a.totalDuration(),
                (r = a._start) > o && this._sort && a._ts && !this._lock
                  ? ((this._lock = 1), (Dt(this, a, r - a._delay, 1)._lock = 0))
                  : (o = r),
                r < 0 &&
                a._ts &&
                ((s -= r),
                  ((!n && !this._dp) || (n && n.smoothChildTiming)) &&
                  ((this._start += r / this._ts), (this._time -= r), (this._tTime -= r)),
                  this.shiftChildren(-r, !1, -1e20),
                  (o = 0)),
                (i = Rt(a)) > s && a._ts && (s = i),
                (a = e);
            Ft(this, this === _ && this._time > s ? this._time : Math.min(1e8, s), 1),
              (this._dirty = 0);
          }
          return this._tDur;
        }),
        (e.updateRoot = function (t) {
          if ((_._ts && (gt(_, zt(t, _)), (b = he.frame)), he.frame >= at)) {
            at += C.autoSleep || 120;
            var e = _._first;
            if ((!e || !e._ts) && C.autoSleep && he._listeners.length < 2) {
              for (; e && !e._ts;) e = e._next;
              e || he.sleep();
            }
          }
        }),
        e
      );
    })(Ce);
    bt(Te.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
    var ke,
      Oe = function (t, e, i, r, n, s, a, o, l) {
        A(r) && (r = r(n || 0, t, s));
        var u,
          c = t[e],
          h =
            'get' !== i
              ? i
              : A(c)
                ? l
                  ? t[e.indexOf('set') || !A(t['get' + e.substr(3)]) ? e : 'get' + e.substr(3)](l)
                  : t[e]()
                : c,
          d = A(c) ? (l ? Ie : De) : Ae;
        if (
          (R(r) &&
            (~r.indexOf('random(') && (r = Zt(r)),
              '=' === r.charAt(1) &&
              (r =
                parseFloat(h) +
                parseFloat(r.substr(2)) * ('-' === r.charAt(0) ? -1 : 1) +
                (Nt(h) || 0))),
            h !== r)
        )
          return isNaN(h + r)
            ? (!c && !(e in t) && W(e, r),
              function (t, e, i, r, n, s, a) {
                var o,
                  l,
                  u,
                  c,
                  h,
                  d,
                  f,
                  p,
                  _ = new Xe(this._pt, t, e, 0, 1, $e, null, n),
                  m = 0,
                  g = 0;
                for (
                  _.b = i,
                  _.e = r,
                  i += '',
                  (f = ~(r += '').indexOf('random(')) && (r = Zt(r)),
                  s && (s((p = [i, r]), t, e), (i = p[0]), (r = p[1])),
                  l = i.match(Y) || [];
                  (o = Y.exec(r));

                )
                  (c = o[0]),
                    (h = r.substring(m, o.index)),
                    u ? (u = (u + 1) % 5) : 'rgba(' === h.substr(-5) && (u = 1),
                    c !== l[g++] &&
                    ((d = parseFloat(l[g - 1]) || 0),
                      (_._pt = {
                        _next: _._pt,
                        p: h || 1 === g ? h : ',',
                        s: d,
                        c:
                          '=' === c.charAt(1)
                            ? parseFloat(c.substr(2)) * ('-' === c.charAt(0) ? -1 : 1)
                            : parseFloat(c) - d,
                        m: u && u < 4 ? Math.round : 0,
                      }),
                      (m = Y.lastIndex));
                return (
                  (_.c = m < r.length ? r.substring(m, r.length) : ''),
                  (_.fp = a),
                  (X.test(r) || f) && (_.e = 0),
                  (this._pt = _),
                  _
                );
              }.call(this, t, e, h, r, d, o || C.stringFilter, l))
            : ((u = new Xe(
              this._pt,
              t,
              e,
              +h || 0,
              r - (h || 0),
              'boolean' == typeof c ? Be : je,
              0,
              d
            )),
              l && (u.fp = l),
              a && u.modifier(a, this, t),
              (this._pt = u));
      },
      Se = function (t, e, i, r, n, s) {
        var a, o, l, u;
        if (
          nt[t] &&
          !1 !==
          (a = new nt[t]()).init(
            n,
            a.rawVars
              ? e[t]
              : (function (t, e, i, r, n) {
                if ((A(t) && (t = Ee(t, n, e, i, r)), !F(t) || (t.style && t.nodeType) || $(t)))
                  return R(t) ? Ee(t, n, e, i, r) : t;
                var s,
                  a = {};
                for (s in t) a[s] = Ee(t[s], n, e, i, r);
                return a;
              })(e[t], r, n, s, i),
            i,
            r,
            s
          ) &&
          ((i._pt = o = new Xe(i._pt, n, t, 0, 1, a.render, a, 0, a.priority)), i !== w)
        )
          for (l = i._ptLookup[i._targets.indexOf(n)], u = a._props.length; u--;)
            l[a._props[u]] = o;
        return a;
      },
      Me = function t(e, i) {
        var r,
          n,
          s,
          a,
          o,
          l,
          u,
          c,
          h,
          d,
          f,
          p,
          m = e.vars,
          g = m.ease,
          v = m.startAt,
          y = m.immediateRender,
          b = m.lazy,
          w = m.onUpdate,
          x = m.onUpdateParams,
          C = m.callbackScope,
          O = m.runBackwards,
          S = m.yoyoEase,
          M = m.keyframes,
          E = m.autoRevert,
          P = e._dur,
          z = e._startAt,
          R = e._targets,
          A = e.parent,
          D = A && 'nested' === A.data ? A.parent._targets : R,
          I = 'auto' === e._overwrite,
          F = e.timeline;
        if (
          (!F || (M && g) || (g = 'none'),
            (e._ease = ge(g, T.ease)),
            (e._yEase = S ? me(ge(!0 === S ? g : S, T.ease)) : 0),
            S && e._yoyo && !e._repeat && ((S = e._yEase), (e._yEase = e._ease), (e._ease = S)),
            !F)
        ) {
          if ((z && z.render(-1, !0).kill(), v)) {
            if (
              (St(
                (e._startAt = Re.set(
                  R,
                  bt(
                    {
                      data: 'isStart',
                      overwrite: !1,
                      parent: A,
                      immediateRender: !0,
                      lazy: L(b),
                      startAt: null,
                      delay: 0,
                      onUpdate: w,
                      onUpdateParams: x,
                      callbackScope: C,
                      stagger: 0,
                    },
                    v
                  )
                ))
              ),
                y)
            )
              if (i > 0) !E && (e._startAt = 0);
              else if (P) return;
          } else if (O && P)
            if (z) !E && (e._startAt = 0);
            else if (
              (i && (y = !1),
                St(
                  (e._startAt = Re.set(
                    R,
                    xt(Tt(m, et), {
                      overwrite: !1,
                      data: 'isFromStart',
                      lazy: y && L(b),
                      immediateRender: y,
                      stagger: 0,
                      parent: A,
                    })
                  ))
                ),
                y)
            ) {
              if (!i) return;
            } else t(e._startAt, k);
          for (
            r = Tt(m, et),
            e._pt = 0,
            p = (c = R[0] ? ct(R[0]).harness : 0) && m[c.prop],
            b = (P && L(b)) || (b && !P),
            n = 0;
            n < R.length;
            n++
          ) {
            if (
              ((u = (o = R[n])._gsap || ut(R)[n]._gsap),
                (e._ptLookup[n] = d = {}),
                rt[u.id] && mt(),
                (f = D === R ? n : D.indexOf(o)),
                c &&
                !1 !== (h = new c()).init(o, p || r, e, f, D) &&
                ((e._pt = a = new Xe(e._pt, o, h.name, 0, 1, h.render, h, 0, h.priority)),
                  h._props.forEach(function (t) {
                    d[t] = a;
                  }),
                  h.priority && (l = 1)),
                !c || p)
            )
              for (s in r)
                nt[s] && (h = Se(s, r, e, f, o, D))
                  ? h.priority && (l = 1)
                  : (d[s] = a = Oe.call(e, o, s, 'get', r[s], f, D, 0, m.stringFilter));
            e._op && e._op[n] && e.kill(o, e._op[n]),
              I && e._pt && ((ke = e), _.killTweensOf(o, d, 'started'), (ke = 0)),
              e._pt && b && (rt[u.id] = 1);
          }
          l && He(e), e._onInit && e._onInit(e);
        }
        (e._from = !F && !!m.runBackwards), (e._onUpdate = w), (e._initted = 1);
      },
      Ee = function (t, e, i, r, n) {
        return A(t) ? t.call(e, i, r, n) : R(t) && ~t.indexOf('random(') ? Zt(t) : t;
      },
      Pe = lt + 'repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase',
      ze = (Pe + ',id,stagger,delay,duration,paused').split(','),
      Re = (function (t) {
        function e(e, i, r, n) {
          var s;
          'number' == typeof i && ((r.duration = i), (i = r), (r = null));
          var a,
            o,
            l,
            u,
            c,
            h,
            d,
            p,
            m = (s = t.call(this, n ? i : kt(i), r) || this).vars,
            g = m.duration,
            v = m.delay,
            y = m.immediateRender,
            b = m.stagger,
            w = m.overwrite,
            x = m.keyframes,
            T = m.defaults,
            O = s.parent,
            S = ($(e) ? D(e[0]) : 'length' in i) ? [e] : Ht(e);
          if (
            ((s._targets = S.length
              ? ut(S)
              : Z('GSAP target ' + e + ' not found. https://greensock.com', !C.nullTargetWarn) ||
              []),
              (s._ptLookup = []),
              (s._overwrite = w),
              x || b || B(g) || B(v))
          ) {
            if (
              ((i = s.vars),
                (a = s.timeline = new Te({ data: 'nested', defaults: T || {} })).kill(),
                (a.parent = f(s)),
                x)
            )
              bt(a.vars.defaults, { ease: 'none' }),
                x.forEach(function (t) {
                  return a.to(S, t, '>');
                });
            else {
              if (((u = S.length), (d = b ? qt(b) : tt), F(b)))
                for (c in b) ~Pe.indexOf(c) && (p || (p = {}), (p[c] = b[c]));
              for (o = 0; o < u; o++) {
                for (c in ((l = {}), i)) ze.indexOf(c) < 0 && (l[c] = i[c]);
                (l.stagger = 0),
                  p && xt(l, p),
                  i.yoyoEase && !i.repeat && (l.yoyoEase = i.yoyoEase),
                  (h = S[o]),
                  (l.duration = +Ee(g, f(s), o, h, S)),
                  (l.delay = (+Ee(v, f(s), o, h, S) || 0) - s._delay),
                  !b &&
                  1 === u &&
                  l.delay &&
                  ((s._delay = v = l.delay), (s._start += v), (l.delay = 0)),
                  a.to(h, l, d(o, h, S));
              }
              g = v = 0;
            }
            g || s.duration((g = a.duration()));
          } else s.timeline = 0;
          return (
            !0 === w && ((ke = f(s)), _.killTweensOf(S), (ke = 0)),
            O && At(O, f(s)),
            (y ||
              (!g &&
                !x &&
                s._start === O._time &&
                L(y) &&
                (function t(e) {
                  return !e || (e._ts && t(e.parent));
                })(f(s)) &&
                'nested' !== O.data)) &&
            ((s._tTime = -k), s.render(Math.max(0, -v))),
            s
          );
        }
        p(e, t);
        var i = e.prototype;
        return (
          (i.render = function (t, e, i) {
            var r,
              n,
              s,
              a,
              o,
              l,
              u,
              c,
              h,
              d = this._time,
              f = this._tDur,
              p = this._dur,
              _ = t > f - k && t >= 0 ? f : t < k ? 0 : t;
            if (p) {
              if (_ !== this._tTime || !t || i || (this._startAt && this._zTime < 0 != t < 0)) {
                if (((r = _), (c = this.timeline), this._repeat)) {
                  if (
                    ((a = p + this._rDelay),
                      ((r = ft(_ % a)) > p || f === _) && (r = p),
                      (s = ~~(_ / a)) && s === _ / a && ((r = p), s--),
                      (l = this._yoyo && 1 & s) && ((h = this._yEase), (r = p - r)),
                      (o = Pt(this._tTime, a)),
                      r === d && !i && this._initted)
                  )
                    return this;
                  s !== o &&
                    (!this.vars.repeatRefresh ||
                      l ||
                      this._lock ||
                      ((this._lock = i = 1), (this.render(a * s, !0).invalidate()._lock = 0)));
                }
                if (!this._initted && It(this, r, i, e)) return (this._tTime = 0), this;
                for (
                  this._tTime = _,
                  this._time = r,
                  !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                  this.ratio = u = (h || this._ease)(r / p),
                  this._from && (this.ratio = u = 1 - u),
                  d || !r || e || ee(this, 'onStart'),
                  n = this._pt;
                  n;

                )
                  n.r(u, n.d), (n = n._next);
                (c && c.render(t < 0 ? t : !r && l ? -k : c._dur * u, e, i)) ||
                  (this._startAt && (this._zTime = t)),
                  this._onUpdate &&
                  !e &&
                  (t < 0 && this._startAt && this._startAt.render(t, !0, i),
                    ee(this, 'onUpdate')),
                  this._repeat &&
                  s !== o &&
                  this.vars.onRepeat &&
                  !e &&
                  this.parent &&
                  ee(this, 'onRepeat'),
                  (_ !== this._tDur && _) ||
                  this._tTime !== _ ||
                  (t < 0 && this._startAt && !this._onUpdate && this._startAt.render(t, !0, i),
                    (t || !p) && ((t && this._ts > 0) || (!_ && this._ts < 0)) && St(this, 1),
                    e ||
                    (t < 0 && !d) ||
                    (ee(this, _ === f ? 'onComplete' : 'onReverseComplete', !0),
                      this._prom && this._prom()));
              }
            } else
              !(function (t, e, i, r) {
                var n,
                  s = t._zTime < 0 ? 0 : 1,
                  a = e < 0 ? 0 : 1,
                  o = t._rDelay,
                  l = 0;
                if (
                  (o &&
                    t._repeat &&
                    ((l = Ut(0, t._tDur, e)),
                      Pt(l, o) !== Pt(t._tTime, o) &&
                      ((s = 1 - a), t.vars.repeatRefresh && t._initted && t.invalidate())),
                    (t._initted || !It(t, e, r, i)) &&
                    (a !== s || r || t._zTime === k || (!e && t._zTime)))
                ) {
                  for (
                    t._zTime = e || (i ? k : 0),
                    t.ratio = a,
                    t._from && (a = 1 - a),
                    t._time = 0,
                    t._tTime = l,
                    i || ee(t, 'onStart'),
                    n = t._pt;
                    n;

                  )
                    n.r(a, n.d), (n = n._next);
                  !a && t._startAt && !t._onUpdate && t._start && t._startAt.render(e, !0, r),
                    t._onUpdate && (i || ee(t, 'onUpdate')),
                    l && t._repeat && !i && t.parent && ee(t, 'onRepeat'),
                    (e >= t._tDur || e < 0) &&
                    t.ratio === a &&
                    (t.ratio && St(t, 1),
                      i ||
                      (ee(t, t.ratio ? 'onComplete' : 'onReverseComplete', !0),
                        t._prom && t._prom()));
                }
              })(this, t, e, i);
            return this;
          }),
          (i.targets = function () {
            return this._targets;
          }),
          (i.invalidate = function () {
            return (
              (this._pt = this._op = this._startAt = this._onUpdate = this._act = this._lazy = 0),
              (this._ptLookup = []),
              this.timeline && this.timeline.invalidate(),
              t.prototype.invalidate.call(this)
            );
          }),
          (i.kill = function (t, e) {
            if (
              (void 0 === e && (e = 'all'),
                !(t || (e && 'all' !== e)) && ((this._lazy = 0), this.parent))
            )
              return ie(this);
            if (this.timeline)
              return this.timeline.killTweensOf(t, e, ke && !0 !== ke.vars.overwrite), this;
            var i,
              r,
              n,
              s,
              a,
              o,
              l,
              u = this._targets,
              c = t ? Ht(t) : u,
              h = this._ptLookup,
              d = this._pt;
            if (
              (!e || 'all' === e) &&
              (function (t, e) {
                for (var i = t.length, r = i === e.length; r && i-- && t[i] === e[i];);
                return i < 0;
              })(u, c)
            )
              return ie(this);
            for (
              i = this._op = this._op || [],
              'all' !== e &&
              (R(e) &&
                ((a = {}),
                  dt(e, function (t) {
                    return (a[t] = 1);
                  }),
                  (e = a)),
                (e = (function (t, e) {
                  var i,
                    r,
                    n,
                    s,
                    a = t[0] ? ct(t[0]).harness : 0,
                    o = a && a.aliases;
                  if (!o) return e;
                  for (r in ((i = xt({}, e)), o))
                    if ((r in i)) for (n = (s = o[r].split(',')).length; n--;) i[s[n]] = i[r];
                  return i;
                })(u, e))),
              l = u.length;
              l--;

            )
              if (~c.indexOf(u[l]))
                for (a in ((r = h[l]),
                  'all' === e ? ((i[l] = e), (s = r), (n = {})) : ((n = i[l] = i[l] || {}), (s = e)),
                  s))
                  (o = r && r[a]) &&
                    (('kill' in o.d && !0 !== o.d.kill(a)) || Ot(this, o, '_pt'), delete r[a]),
                    'all' !== n && (n[a] = 1);
            return this._initted && !this._pt && d && ie(this), this;
          }),
          (e.to = function (t, i) {
            return new e(t, i, arguments[2]);
          }),
          (e.from = function (t, i) {
            return new e(t, _t(arguments, 1));
          }),
          (e.delayedCall = function (t, i, r, n) {
            return new e(i, 0, {
              immediateRender: !1,
              lazy: !1,
              overwrite: !1,
              delay: t,
              onComplete: i,
              onReverseComplete: i,
              onCompleteParams: r,
              onReverseCompleteParams: r,
              callbackScope: n,
            });
          }),
          (e.fromTo = function (t, i, r) {
            return new e(t, _t(arguments, 2));
          }),
          (e.set = function (t, i) {
            return (i.duration = 0), i.repeatDelay || (i.repeat = 0), new e(t, i);
          }),
          (e.killTweensOf = function (t, e, i) {
            return _.killTweensOf(t, e, i);
          }),
          e
        );
      })(Ce);
    bt(Re.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }),
      dt('staggerTo,staggerFrom,staggerFromTo', function (t) {
        Re[t] = function () {
          var e = new Te(),
            i = Vt.call(arguments, 0);
          return i.splice('staggerFromTo' === t ? 5 : 4, 0, 0), e[t].apply(e, i);
        };
      });
    var Ae = function (t, e, i) {
      return (t[e] = i);
    },
      De = function (t, e, i) {
        return t[e](i);
      },
      Ie = function (t, e, i, r) {
        return t[e](r.fp, i);
      },
      Fe = function (t, e, i) {
        return t.setAttribute(e, i);
      },
      Le = function (t, e) {
        return A(t[e]) ? De : I(t[e]) && t.setAttribute ? Fe : Ae;
      },
      je = function (t, e) {
        return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4, e);
      },
      Be = function (t, e) {
        return e.set(e.t, e.p, !!(e.s + e.c * t), e);
      },
      $e = function (t, e) {
        var i = e._pt,
          r = '';
        if (!t && e.b) r = e.b;
        else if (1 === t && e.e) r = e.e;
        else {
          for (; i;)
            (r = i.p + (i.m ? i.m(i.s + i.c * t) : Math.round(1e4 * (i.s + i.c * t)) / 1e4) + r),
              (i = i._next);
          r += e.c;
        }
        e.set(e.t, e.p, r, e);
      },
      Ue = function (t, e) {
        for (var i = e._pt; i;) i.r(t, i.d), (i = i._next);
      },
      Ne = function (t, e, i, r) {
        for (var n, s = this._pt; s;) (n = s._next), s.p === r && s.modifier(t, e, i), (s = n);
      },
      Ve = function (t) {
        for (var e, i, r = this._pt; r;)
          (i = r._next),
            (r.p === t && !r.op) || r.op === t ? Ot(this, r, '_pt') : r.dep || (e = 1),
            (r = i);
        return !e;
      },
      Ye = function (t, e, i, r) {
        r.mSet(t, e, r.m.call(r.tween, i, r.mt), r);
      },
      He = function (t) {
        for (var e, i, r, n, s = t._pt; s;) {
          for (e = s._next, i = r; i && i.pr > s.pr;) i = i._next;
          (s._prev = i ? i._prev : n) ? (s._prev._next = s) : (r = s),
            (s._next = i) ? (i._prev = s) : (n = s),
            (s = e);
        }
        t._pt = r;
      },
      Xe = (function () {
        function t(t, e, i, r, n, s, a, o, l) {
          (this.t = e),
            (this.s = r),
            (this.c = n),
            (this.p = i),
            (this.r = s || je),
            (this.d = a || this),
            (this.set = o || Ae),
            (this.pr = l || 0),
            (this._next = t),
            t && (t._prev = this);
        }
        return (
          (t.prototype.modifier = function (t, e, i) {
            (this.mSet = this.mSet || this.set),
              (this.set = Ye),
              (this.m = t),
              (this.mt = i),
              (this.tween = e);
          }),
          t
        );
      })();
    dt(
      lt +
      'parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert',
      function (t) {
        return (et[t] = 1);
      }
    ),
      (G.TweenMax = G.TweenLite = Re),
      (G.TimelineLite = G.TimelineMax = Te),
      (_ = new Te({
        sortChildren: !1,
        defaults: T,
        autoRemoveChildren: !0,
        id: 'root',
        smoothChildTiming: !0,
      })),
      (C.stringFilter = ce);
    var qe = {
      registerPlugin: function () {
        for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
        e.forEach(function (t) {
          return (function (t) {
            var e = (t = (!t.name && t.default) || t).name,
              i = A(t),
              r =
                e && !i && t.init
                  ? function () {
                    this._props = [];
                  }
                  : t,
              n = { init: tt, render: Ue, add: Oe, kill: Ve, modifier: Ne, rawVars: 0 },
              s = { targetTest: 0, get: 0, getSetter: Le, aliases: {}, register: 0 };
            if ((de(), t !== r)) {
              if (nt[e]) return;
              bt(r, bt(Tt(t, n), s)),
                xt(r.prototype, xt(n, Tt(t, s))),
                (nt[(r.prop = e)] = r),
                t.targetTest && (ot.push(r), (et[e] = 1)),
                (e = ('css' === e ? 'CSS' : e.charAt(0).toUpperCase() + e.substr(1)) + 'Plugin');
            }
            K(e, r), t.register && t.register(Qe, r, Xe);
          })(t);
        });
      },
      timeline: function (t) {
        return new Te(t);
      },
      getTweensOf: function (t, e) {
        return _.getTweensOf(t, e);
      },
      getProperty: function (t, e, i, r) {
        R(t) && (t = Ht(t)[0]);
        var n = ct(t || {}).get,
          s = i ? yt : vt;
        return (
          'native' === i && (i = ''),
          t
            ? e
              ? s(((nt[e] && nt[e].get) || n)(t, e, i, r))
              : function (e, i, r) {
                return s(((nt[e] && nt[e].get) || n)(t, e, i, r));
              }
            : t
        );
      },
      quickSetter: function (t, e, i) {
        if ((t = Ht(t)).length > 1) {
          var r = t.map(function (t) {
            return Qe.quickSetter(t, e, i);
          }),
            n = r.length;
          return function (t) {
            for (var e = n; e--;) r[e](t);
          };
        }
        t = t[0] || {};
        var s = nt[e],
          a = ct(t),
          o = s
            ? function (e) {
              var r = new s();
              (w._pt = 0), r.init(t, i ? e + i : e, w, 0, [t]), r.render(1, r), w._pt && Ue(1, w);
            }
            : a.set(t, e);
        return s
          ? o
          : function (r) {
            return o(t, e, i ? r + i : r, a, 1);
          };
      },
      isTweening: function (t) {
        return _.getTweensOf(t, !0).length > 0;
      },
      defaults: function (t) {
        return t && t.ease && (t.ease = ge(t.ease, T.ease)), Ct(T, t || {});
      },
      config: function (t) {
        return Ct(C, t || {});
      },
      registerEffect: function (t) {
        var e = t.name,
          i = t.effect,
          r = t.plugins,
          n = t.defaults,
          s = t.extendTimeline;
        (r || '').split(',').forEach(function (t) {
          return t && !nt[t] && !G[t] && Z(e + ' effect requires ' + t + ' plugin.');
        }),
          (st[e] = function (t, e) {
            return i(Ht(t), bt(e || {}, n));
          }),
          s &&
          (Te.prototype[e] = function (t, i, r) {
            return this.add(st[e](t, F(i) ? i : (r = i) && {}), r);
          });
      },
      registerEase: function (t, e) {
        fe[t] = ge(e);
      },
      parseEase: function (t, e) {
        return arguments.length ? ge(t, e) : fe;
      },
      getById: function (t) {
        return _.getById(t);
      },
      exportRoot: function (t, e) {
        void 0 === t && (t = {});
        var i,
          r,
          n = new Te(t);
        for (
          n.smoothChildTiming = L(t.smoothChildTiming),
          _.remove(n),
          n._dp = 0,
          n._time = n._tTime = _._time,
          i = _._first;
          i;

        )
          (r = i._next),
            (!e && !i._dur && i instanceof Re && i.vars.onComplete === i._targets[0]) ||
            Dt(n, i, i._start - i._delay),
            (i = r);
        return Dt(_, n, 0), n;
      },
      utils: {
        wrap: function t(e, i, r) {
          var n = i - e;
          return $(e)
            ? Wt(e, t(0, e.length), i)
            : $t(r, function (t) {
              return ((n + ((t - e) % n)) % n) + e;
            });
        },
        wrapYoyo: function t(e, i, r) {
          var n = i - e,
            s = 2 * n;
          return $(e)
            ? Wt(e, t(0, e.length - 1), i)
            : $t(r, function (t) {
              return e + ((t = (s + ((t - e) % s)) % s) > n ? s - t : t);
            });
        },
        distribute: qt,
        random: Qt,
        snap: Jt,
        normalize: function (t, e, i) {
          return Kt(t, e, 0, 1, i);
        },
        getUnit: Nt,
        clamp: function (t, e, i) {
          return $t(i, function (i) {
            return Ut(t, e, i);
          });
        },
        splitColor: se,
        toArray: Ht,
        mapRange: Kt,
        pipe: function () {
          for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
          return function (t) {
            return e.reduce(function (t, e) {
              return e(t);
            }, t);
          };
        },
        unitize: function (t, e) {
          return function (i) {
            return t(parseFloat(i)) + (e || Nt(i));
          };
        },
        interpolate: function t(e, i, r, n) {
          var s = isNaN(e + i)
            ? 0
            : function (t) {
              return (1 - t) * e + t * i;
            };
          if (!s) {
            var a,
              o,
              l,
              u,
              c,
              h = R(e),
              d = {};
            if ((!0 === r && (n = 1) && (r = null), h)) (e = { p: e }), (i = { p: i });
            else if ($(e) && !$(i)) {
              for (l = [], u = e.length, c = u - 2, o = 1; o < u; o++) l.push(t(e[o - 1], e[o]));
              u--,
                (s = function (t) {
                  t *= u;
                  var e = Math.min(c, ~~t);
                  return l[e](t - e);
                }),
                (r = i);
            } else n || (e = xt($(e) ? [] : {}, e));
            if (!l) {
              for (a in i) Oe.call(d, e, a, 'get', i[a]);
              s = function (t) {
                return Ue(t, d) || (h ? e.p : e);
              };
            }
          }
          return $t(r, s);
        },
        shuffle: Xt,
      },
      install: Q,
      effects: st,
      ticker: he,
      updateRoot: Te.updateRoot,
      plugins: nt,
      globalTimeline: _,
      core: {
        PropTween: Xe,
        globals: K,
        Tween: Re,
        Timeline: Te,
        Animation: Ce,
        getCache: ct,
        _removeLinkedListItem: Ot,
      },
    };
    dt('to,from,fromTo,delayedCall,set,killTweensOf', function (t) {
      return (qe[t] = Re[t]);
    }),
      he.add(Te.updateRoot),
      (w = qe.to({}, { duration: 0 }));
    var Ge = function (t, e) {
      for (var i = t._pt; i && i.p !== e && i.op !== e && i.fp !== e;) i = i._next;
      return i;
    },
      Je = function (t, e) {
        return {
          name: t,
          rawVars: 1,
          init: function (t, i, r) {
            r._onInit = function (t) {
              var r, n;
              if (
                (R(i) &&
                  ((r = {}),
                    dt(i, function (t) {
                      return (r[t] = 1);
                    }),
                    (i = r)),
                  e)
              ) {
                for (n in ((r = {}), i)) r[n] = e(i[n]);
                i = r;
              }
              !(function (t, e) {
                var i,
                  r,
                  n,
                  s = t._targets;
                for (i in e)
                  for (r = s.length; r--;)
                    (n = t._ptLookup[r][i]) &&
                      (n = n.d) &&
                      (n._pt && (n = Ge(n, i)), n && n.modifier && n.modifier(e[i], t, s[r], i));
              })(t, i);
            };
          },
        };
      },
      Qe =
        qe.registerPlugin(
          {
            name: 'attr',
            init: function (t, e, i, r, n) {
              for (var s in e)
                this.add(t, 'setAttribute', (t.getAttribute(s) || 0) + '', e[s], r, n, 0, 0, s),
                  this._props.push(s);
            },
          },
          {
            name: 'endArray',
            init: function (t, e) {
              for (var i = e.length; i--;) this.add(t, i, t[i] || 0, e[i]);
            },
          },
          Je('roundProps', Gt),
          Je('modifiers'),
          Je('snap', Jt)
        ) || qe;
    (Re.version = Te.version = Qe.version = '3.2.3'),
      (y = 1),
      j() && de(),
      fe.Power0,
      fe.Power1,
      fe.Power2,
      fe.Power3,
      fe.Power4,
      fe.Linear,
      fe.Quad,
      fe.Cubic,
      fe.Quart,
      fe.Quint,
      fe.Strong,
      fe.Elastic,
      fe.Back,
      fe.SteppedEase,
      fe.Bounce,
      fe.Sine,
      fe.Expo,
      fe.Circ;
    /*!
     * CSSPlugin 3.2.3
     * https://greensock.com
     *
     * Copyright 2008-2020, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */
    var We,
      Ze,
      Ke,
      ti,
      ei,
      ii,
      ri,
      ni,
      si = {},
      ai = 180 / Math.PI,
      oi = Math.PI / 180,
      li = Math.atan2,
      ui = /([A-Z])/g,
      ci = /(?:left|right|width|margin|padding|x)/i,
      hi = /[\s,\(]\S/,
      di = { autoAlpha: 'opacity,visibility', scale: 'scaleX,scaleY', alpha: 'opacity' },
      fi = function (t, e) {
        return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
      },
      pi = function (t, e) {
        return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
      },
      _i = function (t, e) {
        return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e);
      },
      mi = function (t, e) {
        var i = e.s + e.c * t;
        e.set(e.t, e.p, ~~(i + (i < 0 ? -0.5 : 0.5)) + e.u, e);
      },
      gi = function (t, e) {
        return e.set(e.t, e.p, t ? e.e : e.b, e);
      },
      vi = function (t, e) {
        return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e);
      },
      yi = function (t, e, i) {
        return (t.style[e] = i);
      },
      bi = function (t, e, i) {
        return t.style.setProperty(e, i);
      },
      wi = function (t, e, i) {
        return (t._gsap[e] = i);
      },
      xi = function (t, e, i) {
        return (t._gsap.scaleX = t._gsap.scaleY = i);
      },
      Ci = function (t, e, i, r, n) {
        var s = t._gsap;
        (s.scaleX = s.scaleY = i), s.renderTransform(n, s);
      },
      Ti = function (t, e, i, r, n) {
        var s = t._gsap;
        (s[e] = i), s.renderTransform(n, s);
      },
      ki = 'transform',
      Oi = ki + 'Origin',
      Si = function (t, e) {
        var i = Ze.createElementNS
          ? Ze.createElementNS((e || 'http://www.w3.org/1999/xhtml').replace(/^https/, 'http'), t)
          : Ze.createElement(t);
        return i.style ? i : Ze.createElement(t);
      },
      Mi = function t(e, i, r) {
        var n = getComputedStyle(e);
        return (
          n[i] ||
          n.getPropertyValue(i.replace(ui, '-$1').toLowerCase()) ||
          n.getPropertyValue(i) ||
          (!r && t(e, Pi(i) || i, 1)) ||
          ''
        );
      },
      Ei = 'O,Moz,ms,Ms,Webkit'.split(','),
      Pi = function (t, e, i) {
        var r = (e || ei).style,
          n = 5;
        if (t in r && !i) return t;
        for (t = t.charAt(0).toUpperCase() + t.substr(1); n-- && !(Ei[n] + t in r););
        return n < 0 ? null : (3 === n ? 'ms' : n >= 0 ? Ei[n] : '') + t;
      },
      zi = function () {
        'undefined' != typeof window &&
          ((We = window),
            (Ze = We.document),
            (Ke = Ze.documentElement),
            (ei = Si('div') || { style: {} }),
            (ii = Si('div')),
            (ki = Pi(ki)),
            (Oi = Pi(Oi)),
            (ei.style.cssText = 'border-width:0;line-height:0;position:absolute;padding:0'),
            (ni = !!Pi('perspective')),
            (ti = 1));
      },
      Ri = function t(e) {
        var i,
          r = Si(
            'svg',
            (this.ownerSVGElement && this.ownerSVGElement.getAttribute('xmlns')) ||
            'http://www.w3.org/2000/svg'
          ),
          n = this.parentNode,
          s = this.nextSibling,
          a = this.style.cssText;
        if ((Ke.appendChild(r), r.appendChild(this), (this.style.display = 'block'), e))
          try {
            (i = this.getBBox()), (this._gsapBBox = this.getBBox), (this.getBBox = t);
          } catch (t) { }
        else this._gsapBBox && (i = this._gsapBBox());
        return (
          n && (s ? n.insertBefore(this, s) : n.appendChild(this)),
          Ke.removeChild(r),
          (this.style.cssText = a),
          i
        );
      },
      Ai = function (t, e) {
        for (var i = e.length; i--;) if (t.hasAttribute(e[i])) return t.getAttribute(e[i]);
      },
      Di = function (t) {
        var e;
        try {
          e = t.getBBox();
        } catch (i) {
          e = Ri.call(t, !0);
        }
        return (
          (e && (e.width || e.height)) || t.getBBox === Ri || (e = Ri.call(t, !0)),
          !e || e.width || e.x || e.y
            ? e
            : {
              x: +Ai(t, ['x', 'cx', 'x1']) || 0,
              y: +Ai(t, ['y', 'cy', 'y1']) || 0,
              width: 0,
              height: 0,
            }
        );
      },
      Ii = function (t) {
        return !(!t.getCTM || (t.parentNode && !t.ownerSVGElement) || !Di(t));
      },
      Fi = function (t, e) {
        if (e) {
          var i = t.style;
          e in si && (e = ki),
            i.removeProperty
              ? (('ms' !== e.substr(0, 2) && 'webkit' !== e.substr(0, 6)) || (e = '-' + e),
                i.removeProperty(e.replace(ui, '-$1').toLowerCase()))
              : i.removeAttribute(e);
        }
      },
      Li = function (t, e, i, r, n, s) {
        var a = new Xe(t._pt, e, i, 0, 1, s ? vi : gi);
        return (t._pt = a), (a.b = r), (a.e = n), t._props.push(i), a;
      },
      ji = { deg: 1, rad: 1, turn: 1 },
      Bi = function (t, e, i, r) {
        var n,
          s,
          a,
          o,
          l = parseFloat(i) || 0,
          u = (i + '').trim().substr((l + '').length) || 'px',
          c = ei.style,
          h = ci.test(e),
          d = 'svg' === t.tagName.toLowerCase(),
          f = (d ? 'client' : 'offset') + (h ? 'Width' : 'Height'),
          p = 'px' === r;
        return r === u || !l || ji[r] || ji[u]
          ? l
          : ((o = t.getCTM && Ii(t)),
            '%' === r && (si[e] || ~e.indexOf('adius'))
              ? ft((l / (o ? t.getBBox()[h ? 'width' : 'height'] : t[f])) * 100)
              : ((c[h ? 'width' : 'height'] = 100 + (p ? u : r)),
                (s = ~e.indexOf('adius') || ('em' === r && t.appendChild && !d) ? t : t.parentNode),
                o && (s = (t.ownerSVGElement || {}).parentNode),
                (s && s !== Ze && s.appendChild) || (s = Ze.body),
                (a = s._gsap) && '%' === r && a.width && h && a.time === he.time
                  ? ft((l / a.width) * 100)
                  : (s === t && (c.position = 'static'),
                    s.appendChild(ei),
                    (n = ei[f]),
                    s.removeChild(ei),
                    (c.position = 'absolute'),
                    h && '%' === r && (((a = ct(s)).time = he.time), (a.width = s[f])),
                    ft(p ? (n * l) / 100 : (100 / n) * l))));
      },
      $i = function (t, e, i, r) {
        var n;
        return (
          ti || zi(),
          e in di && 'transform' !== e && ~(e = di[e]).indexOf(',') && (e = e.split(',')[0]),
          si[e] && 'transform' !== e
            ? ((n = Zi(t, r)),
              (n = 'transformOrigin' !== e ? n[e] : Ki(Mi(t, Oi)) + ' ' + n.zOrigin + 'px'))
            : (!(n = t.style[e]) || 'auto' === n || r || ~(n + '').indexOf('calc(')) &&
            (n = (Hi[e] && Hi[e](t, e, i)) || Mi(t, e) || ht(t, e) || ('opacity' === e ? 1 : 0)),
          i && !~(n + '').indexOf(' ') ? Bi(t, e, n, i) + i : n
        );
      },
      Ui = function (t, e, i, r) {
        if (!i || 'none' === i) {
          var n = Pi(e, t, 1),
            s = n && Mi(t, n, 1);
          s && s !== i && ((e = n), (i = s));
        }
        var a,
          o,
          l,
          u,
          c,
          h,
          d,
          f,
          p,
          _,
          m,
          g,
          v = new Xe(this._pt, t.style, e, 0, 1, $e),
          y = 0,
          b = 0;
        if (
          ((v.b = i),
            (v.e = r),
            (i += ''),
            'auto' == (r += '') && ((t.style[e] = r), (r = Mi(t, e) || r), (t.style[e] = i)),
            ce((a = [i, r])),
            (r = a[1]),
            (l = (i = a[0]).match(V) || []),
            (r.match(V) || []).length)
        ) {
          for (; (o = V.exec(r));)
            (d = o[0]),
              (p = r.substring(y, o.index)),
              c
                ? (c = (c + 1) % 5)
                : ('rgba(' !== p.substr(-5) && 'hsla(' !== p.substr(-5)) || (c = 1),
              d !== (h = l[b++] || '') &&
              ((u = parseFloat(h) || 0),
                (m = h.substr((u + '').length)),
                (g = '=' === d.charAt(1) ? +(d.charAt(0) + '1') : 0) && (d = d.substr(2)),
                (f = parseFloat(d)),
                (_ = d.substr((f + '').length)),
                (y = V.lastIndex - _.length),
                _ || ((_ = _ || C.units[e] || m), y === r.length && ((r += _), (v.e += _))),
                m !== _ && (u = Bi(t, e, h, _) || 0),
                (v._pt = {
                  _next: v._pt,
                  p: p || 1 === b ? p : ',',
                  s: u,
                  c: g ? g * f : f - u,
                  m: c && c < 4 ? Math.round : 0,
                }));
          v.c = y < r.length ? r.substring(y, r.length) : '';
        } else v.r = 'display' === e && 'none' === r ? vi : gi;
        return X.test(r) && (v.e = 0), (this._pt = v), v;
      },
      Ni = { top: '0%', bottom: '100%', left: '0%', right: '100%', center: '50%' },
      Vi = function (t) {
        var e = t.split(' '),
          i = e[0],
          r = e[1] || '50%';
        return (
          ('top' !== i && 'bottom' !== i && 'left' !== r && 'right' !== r) ||
          ((t = i), (i = r), (r = t)),
          (e[0] = Ni[i] || i),
          (e[1] = Ni[r] || r),
          e.join(' ')
        );
      },
      Yi = function (t, e) {
        if (e.tween && e.tween._time === e.tween._dur) {
          var i,
            r,
            n,
            s = e.t,
            a = s.style,
            o = e.u,
            l = s._gsap;
          if ('all' === o || !0 === o) (a.cssText = ''), (r = 1);
          else
            for (n = (o = o.split(',')).length; --n > -1;)
              (i = o[n]), si[i] && ((r = 1), (i = 'transformOrigin' === i ? Oi : ki)), Fi(s, i);
          r &&
            (Fi(s, ki), l && (l.svg && s.removeAttribute('transform'), Zi(s, 1), (l.uncache = 1)));
        }
      },
      Hi = {
        clearProps: function (t, e, i, r, n) {
          if ('isFromStart' !== n.data) {
            var s = (t._pt = new Xe(t._pt, e, i, 0, 0, Yi));
            return (s.u = r), (s.pr = -10), (s.tween = n), t._props.push(i), 1;
          }
        },
      },
      Xi = [1, 0, 0, 1, 0, 0],
      qi = {},
      Gi = function (t) {
        return 'matrix(1, 0, 0, 1, 0, 0)' === t || 'none' === t || !t;
      },
      Ji = function (t) {
        var e = Mi(t, ki);
        return Gi(e) ? Xi : e.substr(7).match(N).map(ft);
      },
      Qi = function (t, e) {
        var i,
          r,
          n,
          s,
          a = t._gsap || ct(t),
          o = t.style,
          l = Ji(t);
        return a.svg && t.getAttribute('transform')
          ? '1,0,0,1,0,0' ===
            (l = [(n = t.transform.baseVal.consolidate().matrix).a, n.b, n.c, n.d, n.e, n.f]).join(
              ','
            )
            ? Xi
            : l
          : (l !== Xi ||
            t.offsetParent ||
            t === Ke ||
            a.svg ||
            ((n = o.display),
              (o.display = 'block'),
              ((i = t.parentNode) && t.offsetParent) ||
              ((s = 1), (r = t.nextSibling), Ke.appendChild(t)),
              (l = Ji(t)),
              n ? (o.display = n) : Fi(t, 'display'),
              s && (r ? i.insertBefore(t, r) : i ? i.appendChild(t) : Ke.removeChild(t))),
            e && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
      },
      Wi = function (t, e, i, r, n, s) {
        var a,
          o,
          l,
          u = t._gsap,
          c = n || Qi(t, !0),
          h = u.xOrigin || 0,
          d = u.yOrigin || 0,
          f = u.xOffset || 0,
          p = u.yOffset || 0,
          _ = c[0],
          m = c[1],
          g = c[2],
          v = c[3],
          y = c[4],
          b = c[5],
          w = e.split(' '),
          x = parseFloat(w[0]) || 0,
          C = parseFloat(w[1]) || 0;
        i
          ? c !== Xi &&
          (o = _ * v - m * g) &&
          ((l = x * (-m / o) + C * (_ / o) - (_ * b - m * y) / o),
            (x = x * (v / o) + C * (-g / o) + (g * b - v * y) / o),
            (C = l))
          : ((x = (a = Di(t)).x + (~w[0].indexOf('%') ? (x / 100) * a.width : x)),
            (C = a.y + (~(w[1] || w[0]).indexOf('%') ? (C / 100) * a.height : C))),
          r || (!1 !== r && u.smooth)
            ? ((y = x - h),
              (b = C - d),
              (u.xOffset = f + (y * _ + b * g) - y),
              (u.yOffset = p + (y * m + b * v) - b))
            : (u.xOffset = u.yOffset = 0),
          (u.xOrigin = x),
          (u.yOrigin = C),
          (u.smooth = !!r),
          (u.origin = e),
          (u.originIsAbsolute = !!i),
          (t.style[Oi] = '0px 0px'),
          s &&
          (Li(s, u, 'xOrigin', h, x),
            Li(s, u, 'yOrigin', d, C),
            Li(s, u, 'xOffset', f, u.xOffset),
            Li(s, u, 'yOffset', p, u.yOffset)),
          t.setAttribute('data-svg-origin', x + ' ' + C);
      },
      Zi = function (t, e) {
        var i = t._gsap || new xe(t);
        if ('x' in i && !e && !i.uncache) return i;
        var r,
          n,
          s,
          a,
          o,
          l,
          u,
          c,
          h,
          d,
          f,
          p,
          _,
          m,
          g,
          v,
          y,
          b,
          w,
          x,
          T,
          k,
          O,
          S,
          M,
          E,
          P,
          z,
          R,
          A,
          D,
          I,
          F = t.style,
          L = i.scaleX < 0,
          j = Mi(t, Oi) || '0';
        return (
          (r = n = s = l = u = c = h = d = f = 0),
          (a = o = 1),
          (i.svg = !(!t.getCTM || !Ii(t))),
          (m = Qi(t, i.svg)),
          i.svg &&
          ((S = !i.uncache && t.getAttribute('data-svg-origin')),
            Wi(t, S || j, !!S || i.originIsAbsolute, !1 !== i.smooth, m)),
          (p = i.xOrigin || 0),
          (_ = i.yOrigin || 0),
          m !== Xi &&
          ((b = m[0]),
            (w = m[1]),
            (x = m[2]),
            (T = m[3]),
            (r = k = m[4]),
            (n = O = m[5]),
            6 === m.length
              ? ((a = Math.sqrt(b * b + w * w)),
                (o = Math.sqrt(T * T + x * x)),
                (l = b || w ? li(w, b) * ai : 0),
                (h = x || T ? li(x, T) * ai + l : 0) && (o *= Math.cos(h * oi)),
                i.svg && ((r -= p - (p * b + _ * x)), (n -= _ - (p * w + _ * T))))
              : ((I = m[6]),
                (A = m[7]),
                (P = m[8]),
                (z = m[9]),
                (R = m[10]),
                (D = m[11]),
                (r = m[12]),
                (n = m[13]),
                (s = m[14]),
                (u = (g = li(I, R)) * ai),
                g &&
                ((S = k * (v = Math.cos(-g)) + P * (y = Math.sin(-g))),
                  (M = O * v + z * y),
                  (E = I * v + R * y),
                  (P = k * -y + P * v),
                  (z = O * -y + z * v),
                  (R = I * -y + R * v),
                  (D = A * -y + D * v),
                  (k = S),
                  (O = M),
                  (I = E)),
                (c = (g = li(-x, R)) * ai),
                g &&
                ((v = Math.cos(-g)),
                  (D = T * (y = Math.sin(-g)) + D * v),
                  (b = S = b * v - P * y),
                  (w = M = w * v - z * y),
                  (x = E = x * v - R * y)),
                (l = (g = li(w, b)) * ai),
                g &&
                ((S = b * (v = Math.cos(g)) + w * (y = Math.sin(g))),
                  (M = k * v + O * y),
                  (w = w * v - b * y),
                  (O = O * v - k * y),
                  (b = S),
                  (k = M)),
                u && Math.abs(u) + Math.abs(l) > 359.9 && ((u = l = 0), (c = 180 - c)),
                (a = ft(Math.sqrt(b * b + w * w + x * x))),
                (o = ft(Math.sqrt(O * O + I * I))),
                (g = li(k, O)),
                (h = Math.abs(g) > 2e-4 ? g * ai : 0),
                (f = D ? 1 / (D < 0 ? -D : D) : 0)),
            i.svg &&
            ((m = t.getAttribute('transform')),
              (i.forceCSS = t.setAttribute('transform', '') || !Gi(Mi(t, ki))),
              m && t.setAttribute('transform', m))),
          Math.abs(h) > 90 &&
          Math.abs(h) < 270 &&
          (L
            ? ((a *= -1), (h += l <= 0 ? 180 : -180), (l += l <= 0 ? 180 : -180))
            : ((o *= -1), (h += h <= 0 ? 180 : -180))),
          (i.x =
            ((i.xPercent = r && Math.round(t.offsetWidth / 2) === Math.round(-r) ? -50 : 0)
              ? 0
              : r) + 'px'),
          (i.y =
            ((i.yPercent = n && Math.round(t.offsetHeight / 2) === Math.round(-n) ? -50 : 0)
              ? 0
              : n) + 'px'),
          (i.z = s + 'px'),
          (i.scaleX = ft(a)),
          (i.scaleY = ft(o)),
          (i.rotation = ft(l) + 'deg'),
          (i.rotationX = ft(u) + 'deg'),
          (i.rotationY = ft(c) + 'deg'),
          (i.skewX = h + 'deg'),
          (i.skewY = d + 'deg'),
          (i.transformPerspective = f + 'px'),
          (i.zOrigin = parseFloat(j.split(' ')[2]) || 0) && (F[Oi] = Ki(j)),
          (i.xOffset = i.yOffset = 0),
          (i.force3D = C.force3D),
          (i.renderTransform = i.svg ? rr : ni ? ir : er),
          (i.uncache = 0),
          i
        );
      },
      Ki = function (t) {
        return (t = t.split(' '))[0] + ' ' + t[1];
      },
      tr = function (t, e, i) {
        var r = Nt(e);
        return ft(parseFloat(e) + parseFloat(Bi(t, 'x', i + 'px', r))) + r;
      },
      er = function (t, e) {
        (e.z = '0px'), (e.rotationY = e.rotationX = '0deg'), (e.force3D = 0), ir(t, e);
      },
      ir = function (t, e) {
        var i = e || this,
          r = i.xPercent,
          n = i.yPercent,
          s = i.x,
          a = i.y,
          o = i.z,
          l = i.rotation,
          u = i.rotationY,
          c = i.rotationX,
          h = i.skewX,
          d = i.skewY,
          f = i.scaleX,
          p = i.scaleY,
          _ = i.transformPerspective,
          m = i.force3D,
          g = i.target,
          v = i.zOrigin,
          y = '',
          b = ('auto' === m && t && 1 !== t) || !0 === m;
        if (v && ('0deg' !== c || '0deg' !== u)) {
          var w,
            x = parseFloat(u) * oi,
            C = Math.sin(x),
            T = Math.cos(x);
          (x = parseFloat(c) * oi),
            (w = Math.cos(x)),
            (s = tr(g, s, C * w * -v)),
            (a = tr(g, a, -Math.sin(x) * -v)),
            (o = tr(g, o, T * w * -v + v));
        }
        '0px' !== _ && (y += 'perspective(' + _ + ') '),
          (r || n) && (y += 'translate(' + r + '%, ' + n + '%) '),
          (b || '0px' !== s || '0px' !== a || '0px' !== o) &&
          (y +=
            '0px' !== o || b
              ? 'translate3d(' + s + ', ' + a + ', ' + o + ') '
              : 'translate(' + s + ', ' + a + ') '),
          '0deg' !== l && (y += 'rotate(' + l + ') '),
          '0deg' !== u && (y += 'rotateY(' + u + ') '),
          '0deg' !== c && (y += 'rotateX(' + c + ') '),
          ('0deg' === h && '0deg' === d) || (y += 'skew(' + h + ', ' + d + ') '),
          (1 === f && 1 === p) || (y += 'scale(' + f + ', ' + p + ') '),
          (g.style[ki] = y || 'translate(0, 0)');
      },
      rr = function (t, e) {
        var i,
          r,
          n,
          s,
          a,
          o = e || this,
          l = o.xPercent,
          u = o.yPercent,
          c = o.x,
          h = o.y,
          d = o.rotation,
          f = o.skewX,
          p = o.skewY,
          _ = o.scaleX,
          m = o.scaleY,
          g = o.target,
          v = o.xOrigin,
          y = o.yOrigin,
          b = o.xOffset,
          w = o.yOffset,
          x = o.forceCSS,
          C = parseFloat(c),
          T = parseFloat(h);
        (d = parseFloat(d)),
          (f = parseFloat(f)),
          (p = parseFloat(p)) && ((f += p = parseFloat(p)), (d += p)),
          d || f
            ? ((d *= oi),
              (f *= oi),
              (i = Math.cos(d) * _),
              (r = Math.sin(d) * _),
              (n = Math.sin(d - f) * -m),
              (s = Math.cos(d - f) * m),
              f &&
              ((p *= oi),
                (a = Math.tan(f - p)),
                (n *= a = Math.sqrt(1 + a * a)),
                (s *= a),
                p && ((a = Math.tan(p)), (i *= a = Math.sqrt(1 + a * a)), (r *= a))),
              (i = ft(i)),
              (r = ft(r)),
              (n = ft(n)),
              (s = ft(s)))
            : ((i = _), (s = m), (r = n = 0)),
          ((C && !~(c + '').indexOf('px')) || (T && !~(h + '').indexOf('px'))) &&
          ((C = Bi(g, 'x', c, 'px')), (T = Bi(g, 'y', h, 'px'))),
          (v || y || b || w) &&
          ((C = ft(C + v - (v * i + y * n) + b)), (T = ft(T + y - (v * r + y * s) + w))),
          (l || u) &&
          ((a = g.getBBox()),
            (C = ft(C + (l / 100) * a.width)),
            (T = ft(T + (u / 100) * a.height))),
          (a = 'matrix(' + i + ',' + r + ',' + n + ',' + s + ',' + C + ',' + T + ')'),
          g.setAttribute('transform', a),
          x && (g.style[ki] = a);
      },
      nr = function (t, e, i, r, n, s) {
        var a,
          o,
          l = R(n),
          u = parseFloat(n) * (l && ~n.indexOf('rad') ? ai : 1),
          c = s ? u * s : u - r,
          h = r + c + 'deg';
        return (
          l &&
          ('short' === (a = n.split('_')[1]) &&
            (c %= 360) != c % 180 &&
            (c += c < 0 ? 360 : -360),
            'cw' === a && c < 0
              ? (c = ((c + 36e9) % 360) - 360 * ~~(c / 360))
              : 'ccw' === a && c > 0 && (c = ((c - 36e9) % 360) - 360 * ~~(c / 360))),
          (t._pt = o = new Xe(t._pt, e, i, r, c, pi)),
          (o.e = h),
          (o.u = 'deg'),
          t._props.push(i),
          o
        );
      },
      sr = function (t, e, i) {
        var r,
          n,
          s,
          a,
          o,
          l,
          u,
          c = ii.style,
          h = i._gsap;
        for (n in ((c.cssText = getComputedStyle(i).cssText + ';position:absolute;display:block;'),
          (c[ki] = e),
          Ze.body.appendChild(ii),
          (r = Zi(ii, 1)),
          si))
          (s = h[n]) !== (a = r[n]) &&
            'perspective,force3D,transformOrigin,svgOrigin'.indexOf(n) < 0 &&
            ((o = Nt(s) !== (u = Nt(a)) ? Bi(i, n, s, u) : parseFloat(s)),
              (l = parseFloat(a)),
              (t._pt = new Xe(t._pt, h, n, o, l - o, fi)),
              (t._pt.u = u || 0),
              t._props.push(n));
        Ze.body.removeChild(ii);
      };
    dt('padding,margin,Width,Radius', function (t, e) {
      var i = 'Top',
        r = 'Right',
        n = 'Bottom',
        s = 'Left',
        a = (e < 3 ? [i, r, n, s] : [i + s, i + r, n + r, n + s]).map(function (i) {
          return e < 2 ? t + i : 'border' + i + t;
        });
      Hi[e > 1 ? 'border' + t : t] = function (t, e, i, r, n) {
        var s, o;
        if (arguments.length < 4)
          return (
            (s = a.map(function (e) {
              return $i(t, e, i);
            })),
            5 === (o = s.join(' ')).split(s[0]).length ? s[0] : o
          );
        (s = (r + '').split(' ')),
          (o = {}),
          a.forEach(function (t, e) {
            return (o[t] = s[e] = s[e] || s[((e - 1) / 2) | 0]);
          }),
          t.init(e, o, n);
      };
    });
    var ar = {
      name: 'css',
      register: zi,
      targetTest: function (t) {
        return t.style && t.nodeType;
      },
      init: function (t, e, i, r, n) {
        var s,
          a,
          o,
          l,
          u,
          c,
          h,
          d,
          f,
          p,
          _,
          m,
          g,
          v,
          y,
          b = this._props,
          w = t.style;
        for (h in (ti || zi(), e))
          if ('autoRound' !== h && ((a = e[h]), !nt[h] || !Se(h, e, i, r, t, n)))
            if (
              ((u = typeof a),
                (c = Hi[h]),
                'function' === u && (u = typeof (a = a.call(i, r, t, n))),
                'string' === u && ~a.indexOf('random(') && (a = Zt(a)),
                c)
            )
              c(this, t, h, a, i) && (y = 1);
            else if ('--' === h.substr(0, 2))
              this.add(
                w,
                'setProperty',
                getComputedStyle(t).getPropertyValue(h) + '',
                a + '',
                r,
                n,
                0,
                0,
                h
              );
            else {
              if (
                ((s = $i(t, h)),
                  (l = parseFloat(s)),
                  (p = 'string' === u && '=' === a.charAt(1) ? +(a.charAt(0) + '1') : 0) &&
                  (a = a.substr(2)),
                  (o = parseFloat(a)),
                  h in di &&
                  ('autoAlpha' === h &&
                    (1 === l && 'hidden' === $i(t, 'visibility') && o && (l = 0),
                      Li(
                        this,
                        w,
                        'visibility',
                        l ? 'inherit' : 'hidden',
                        o ? 'inherit' : 'hidden',
                        !o
                      )),
                    'scale' !== h &&
                    'transform' !== h &&
                    ~(h = di[h]).indexOf(',') &&
                    (h = h.split(',')[0])),
                  (_ = h in si))
              )
                if (
                  (m ||
                    ((g = t._gsap).renderTransform || Zi(t),
                      (v = !1 !== e.smoothOrigin && g.smooth),
                      ((m = this._pt =
                        new Xe(this._pt, w, ki, 0, 1, g.renderTransform, g, 0, -1)).dep = 1)),
                    'scale' === h)
                )
                  (this._pt = new Xe(this._pt, g, 'scaleY', g.scaleY, p ? p * o : o - g.scaleY)),
                    b.push('scaleY', h),
                    (h += 'X');
                else {
                  if ('transformOrigin' === h) {
                    (a = Vi(a)),
                      g.svg
                        ? Wi(t, a, 0, v, 0, this)
                        : ((f = parseFloat(a.split(' ')[2]) || 0) !== g.zOrigin &&
                          Li(this, g, 'zOrigin', g.zOrigin, f),
                          Li(this, w, h, Ki(s), Ki(a)));
                    continue;
                  }
                  if ('svgOrigin' === h) {
                    Wi(t, a, 1, v, 0, this);
                    continue;
                  }
                  if (h in qi) {
                    nr(this, g, h, l, a, p);
                    continue;
                  }
                  if ('smoothOrigin' === h) {
                    Li(this, g, 'smooth', g.smooth, a);
                    continue;
                  }
                  if ('force3D' === h) {
                    g[h] = a;
                    continue;
                  }
                  if ('transform' === h) {
                    sr(this, a, t);
                    continue;
                  }
                }
              else h in w || (h = Pi(h) || h);
              if (_ || ((o || 0 === o) && (l || 0 === l) && !hi.test(a) && h in w))
                o || (o = 0),
                  (d = (s + '').substr((l + '').length)) !==
                  (f = (a + '').substr((o + '').length) || (h in C.units ? C.units[h] : d)) &&
                  (l = Bi(t, h, s, f)),
                  (this._pt = new Xe(
                    this._pt,
                    _ ? g : w,
                    h,
                    l,
                    p ? p * o : o - l,
                    'px' !== f || !1 === e.autoRound || _ ? fi : mi
                  )),
                  (this._pt.u = f || 0),
                  d !== f && ((this._pt.b = s), (this._pt.r = _i));
              else if (h in w) Ui.call(this, t, h, s, a);
              else {
                if (!(h in t)) {
                  W(h, a);
                  continue;
                }
                this.add(t, h, t[h], a, r, n);
              }
              b.push(h);
            }
        y && He(this);
      },
      get: $i,
      aliases: di,
      getSetter: function (t, e, i) {
        var r = di[e];
        return (
          r && r.indexOf(',') < 0 && (e = r),
          e in si && e !== Oi && (t._gsap.x || $i(t, 'x'))
            ? i && ri === i
              ? 'scale' === e
                ? xi
                : wi
              : (ri = i || {}) && ('scale' === e ? Ci : Ti)
            : t.style && !I(t.style[e])
              ? yi
              : ~e.indexOf('-')
                ? bi
                : Le(t, e)
        );
      },
      core: { _removeProperty: Fi, _getMatrix: Qi },
    };
    (Qe.utils.checkPrefix = Pi),
      (function (t, e, i, r) {
        var n = dt(
          'x,y,z,scale,scaleX,scaleY,xPercent,yPercent,' +
          e +
          ',transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective',
          function (t) {
            si[t] = 1;
          }
        );
        dt(e, function (t) {
          (C.units[t] = 'deg'), (qi[t] = 1);
        }),
          (di[n[13]] = 'x,y,z,scale,scaleX,scaleY,xPercent,yPercent,' + e),
          dt(
            '0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY',
            function (t) {
              var e = t.split(':');
              di[e[1]] = n[e[0]];
            }
          );
      })(0, 'rotation,rotationX,rotationY,skewX,skewY'),
      dt(
        'x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective',
        function (t) {
          C.units[t] = 'px';
        }
      ),
      Qe.registerPlugin(ar);
    var or = Qe.registerPlugin(ar) || Qe,
      lr = (or.core.Tween, i(14)),
      ur = i(0),
      cr = {
        props: ['data', 'currentSlide'],
        watch: {
          currentSlide(t) {
            this.$refs.item.map(t => t.classList.remove('is-active')),
              this.$refs.item[t].classList.add('is-active');
          },
        },
        mounted() {
          this.setContainerHeight(), this.setInitialItem(), this.setEventListeners();
        },
        methods: {
          setContainerHeight() {
            const t = this.getContentHeight();
            this.$refs.container &&
              ((this.$refs.container.style.height = ''.concat(t, 'px')),
                this.setContainerPosition());
          },
          getContentHeight() {
            const t = this.$refs.item.map(t => t.offsetHeight);
            return Math.max(...t);
          },
          setContainerPosition() {
            if (window.matchMedia('(min-width: '.concat(lr.a.large, ')')).matches)
              return void (this.$refs.container.style.marginTop = 0);
            const t = this.$refs.container.offsetHeight;
            this.$refs.container.style.marginTop = '-'.concat(t / 2, 'px');
          },
          setInitialItem() {
            const t = or.timeline();
            return (
              t.add(() => {
                this.$refs.item[this.currentSlide].classList.add('is-active');
              }),
              t.add(() => {
                this.$emit('show-slider'), this.$refs.container.classList.add('is-visible');
              }),
              t
            );
          },
          setEventListeners() {
            Object(ur.h)(
              'resize',
              Object(ur.a)(() => this.setContainerHeight(), 250)
            );
          },
        },
      },
      hr = Object(u.a)(
        cr,
        function () {
          var t = this, // current Vue instance
            e = t.$createElement, // createElement method from Vue instance
            i = t._self._c || e; // render method from Vue instance
          return i('div', { ref: 'container', staticClass: 'hero-text-block' }, [
            i('div', { staticClass: 'hero-text-block__card' }, [
              i(
                'div',
                { staticClass: 'hero-text-block__wrapper' },
                // Loop through slides
                t._l(t.data.slides, function (e, r) {
                  return i(
                    'div',
                    {
                      key: r,
                      ref: 'item',
                      refInFor: !0,
                      staticClass: 'hero-text-block__item',
                      style: `background: ${e.panelColor}`,
                    },
                    [
                      // Check if slide has an icon and render it
                      e.icon.url
                        ? i('img', {
                          staticClass: 'hero-text-block__icon lazyload',
                          attrs: { src: e.icon.url, alt: e.icon.alt },
                        })
                        : t._e(),
                      t._v(' '),
                      // Render slide title with dynamic class
                      i(
                        'h2',
                        {
                          staticClass: 'hero-text-block__title',
                          class: [
                            'd1' === t.data.titleFont ? 'd1' : 'd2' === t.data.titleFont ? 'd2' : 'd3',
                          ],
                          style: `color: ${e.headingColor}`,
                        },
                        [t._v('\n          ' + t._s(e.title) + '\n        ')]
                      ),
                      t._v(' '),
                      // Render different button types based on slide data
                      e.link && 'button--secondary' === e.ctaTheme
                        ? i(
                          'a',
                          {
                            staticClass: 'button button--secondary hero-text-block__link',
                            attrs: { href: e.link },
                          },
                          [t._v('\n          ' + t._s(e.ctaText) + '\n        ')]
                        )
                        : e.link && 'button--primary' === e.ctaTheme
                          ? i(
                            'a',
                            {
                              staticClass: 'button button--primary hero-text-block__link',
                              attrs: { href: e.link },
                              style: `color: ${e.ctaTextColor}; background: ${e.ctaBackgroundColor}; border: 1px solid ${e.ctaBackgroundColor}`,
                            },
                            [t._v('\n          ' + t._s(e.ctaText) + '\n        ')]
                          )
                          : t._e(),
                      t._v(' '),
                      // Render navigation if there are multiple slides
                      t.data.slides.length > 1
                        ? i(
                          'nav',
                          { staticClass: 'hero-text-block__nav' },
                          t._l(t.data.slides, function (e, r) {
                            return i(
                              'div',
                              {
                                key: r,
                                staticClass: 'hero-text-block__nav-item',
                                class: { 'is-active': t.currentSlide === r },
                                on: {
                                  click: function (e) {
                                    return t.$emit('update-current-slide', r);
                                  },
                                },
                              },
                              [
                                i('span', { staticClass: 'visually-hidden' }, [
                                  t._v(
                                    '\n              ' +
                                    t._s(r) +
                                    ' ' +
                                    t._s(e.title) +
                                    '\n            '
                                  ),
                                ]),
                              ]
                            );
                          }),
                          0
                        )
                        : t._e(),
                    ]
                  );
                }),
                0
              ),
            ]),
          ]);
        },
        [],
        !1,
        null,
        null,
        null
      ).exports;
    // Register the 'hero' component
    Object(r.b)('hero', {
      // Cache selectors for later use
      cacheSelectors() {
        const t = '[data-section-id="'.concat(this.id, '"]'),
          e = ''.concat(t, ' ').concat('[js-hero="container"]'),
          i = ''.concat(t, ' ').concat('[js-hero="data"]');
        this.cache = { section: t, container: e, data: i };
      },
      // Parse and freeze data
      setData() {
        (this.dataEl = document.querySelector(this.cache.data)),
          (this.data = Object.freeze(JSON.parse(this.dataEl.innerHTML)));
      },
      // Initialize the Vue instance
      init() {
        new s.a({
          el: this.cache.container,
          data: { sectionData: this.data, currentSlide: 0, isSliderVisible: !1 },
          components: { HeroImageSlider: c, HeroSplitImage: d, HeroTextBlock: hr },
          methods: {
            updateCurrentSlide(t) {
              this.currentSlide = t;
            },
            showSlider() {
              this.isSliderVisible = !0;
            },
          },
        });
      },
      // Initialization method to run when the component loads
      onLoad() {
        this.cacheSelectors(), this.setData(), this.init();
      },
    });
  },
});
